/* eslint-disable array-callback-return */
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import SalidasDB from '../firebase/SalidasDB';
import CabeceraOutDB from '../firebase/CabeceraOutDB';
import Alertas from './Alertas';
import { Table, Container, Segment, Header, Form, Dropdown, Button, Input, Icon, Label, Modal, Message } from 'semantic-ui-react';
import { auth, db } from '../firebase/firebaseConfig';
import { getDocs, collection, where, query, doc, writeBatch, deleteDoc, getDoc } from 'firebase/firestore';
import moment from 'moment';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import { ConfirmaModal, Overlay } from '../elementos/General';
import EnviarCorreo from '../funciones/EnviarCorreo';
import BuscadorInput from './BuscadorInput';
import Swal from 'sweetalert2';
import correlativos from '../funciones/correlativosMultiEmpresa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { es } from 'date-fns/locale';
import Spinner from '../components/Spinner';
import { PDFViewer } from "@react-pdf/renderer";
import DocumentoSalidaPDF from "./DocumentoSalidaPDF";
import ModalAtencionST from "./ModalAtencionST";

const Traspasos = () => {
    const user = auth.currentUser;
    const { users } = useContext(UserContext);

    const fechaAdd = new Date();


    const fechaMinima = new Date();
    fechaMinima.setDate(fechaAdd.getDate() - 1);

    const fechaMaxima = new Date();
    fechaMaxima.setDate(fechaAdd.getDate() + 1);

    const [seccionActiva, setSeccionActiva] = useState("CABECERA");
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationAnular, setShowConfirmationAnular] = useState(false);
    const [showConfirmationTraspaso, setShowConfirmationTraspaso] = useState(false);
    const [itemDelete, setItemDelete] = useState(null);
    const [itemAnular, setItemAnular] = useState(false);
    const [alerta, cambiarAlerta] = useState({});
    const [alertaSalida, setAlertasalida] = useState([]);
    const [cabecera, setCabecera] = useState([]);
    const [dataSalida, setDataSalida] = useState([]);
    const [status, setStatus] = useState([]);
    const [usuario, setUsuarios] = useState([]);
    const [transport, setTransport] = useState([]);
    const [cabId, setCabId] = useState('');
    const [date, setDate] = useState(new Date());
    const [nomTipoOut, setNomTipoOut] = useState('');
    const [rut, setRut] = useState('');
    const [entidad, setEntidad] = useState('');
    const [rutSt, setRutSt] = useState('');
    const [entidadSt, setEntidadSt] = useState('');
    const [correo, setCorreo] = useState('');
    const [patente, setPatente] = useState('');
    const [confirmar, setConfirmar] = useState(false);
    const [btnGuardar, setBtnGuardar] = useState(false);
    const [btnAgregar, setBtnAgregar] = useState(true);
    const [btnConfirmar, setBtnConfirmar] = useState(true);
    const [btnNuevo, setBtnNuevo] = useState(true);
    const [folio, setFolio] = useState(null);
    const [guardandoCabecera, setGuardandoCabecera] = useState(false);
    const [modalEquipos, setModalEquipos] = useState(false);
    const [buscadorEquipos, setBuscadorEquipos] = useState('');
    const [confirmandoDocumento, setConfirmandoDocumento] = useState(false);
    const [contratoMantencion, setContratoMantencion] = useState(null);
    const [sts, setSts] = useState([]);
    const [cabeceraMinimizada, setCabeceraMinimizada] = useState(false);
    const [guardandoEquipo, setGuardandoEquipo] = useState(false);
    const [modalAtencionST, setModalAtencionST] = useState(false);
    const [equipoAtencionST, setEquipoAtencionST] = useState(null);
    const [mantencionAtencionST, setMantencionAtencionST] = useState(null);
    const [diasRestantesMantencion, setDiasRestantesMantencion] = useState(null);
    const [preventivaDisponible, setPreventivaDisponible] = useState(false);
    const [consultandoMantencion, setConsultandoMantencion] = useState(false);
    const [ultimosConfirmados, setUltimosConfirmados] = useState([]);
    const [modalPDF, setModalPDF] = useState(false);
    const [cabeceraPDF, setCabeceraPDF] = useState(null);
    const [detallePDF, setDetallePDF] = useState([]);
    const [cargandoPDFId, setCargandoPDFId] = useState(null);

    const [origenTraspaso, setOrigenTraspaso] = useState("");

    const [modalTransportista, setModalTransportista] = useState(false);
    const [asignandoTransportista, setAsignandoTransportista] = useState(false);

    const [correoTransportistaTmp, setCorreoTransportistaTmp] = useState("");
    const [patenteTransportistaTmp, setPatenteTransportistaTmp] = useState("");

    const logisticMedSt = {
        id: 'LOGISTICMED_ST',
        rut: '76550891-6',
        nombre: 'DORMIR BIEN SPA',
        categoria: 'ST_INTERNO',
        interno: true,
    };

    const serviciosTecnicosExternos = [...sts];

    const esStInterno = nomTipoOut === 'PACIENTE A S.T. INTERNO';
    const esPacienteASt = nomTipoOut === 'PACIENTE A S.TECNICO';
    const esStAPaciente = nomTipoOut === 'S.TECNICO A PACIENTE';

    const esRetornoST =
        origenTraspaso === "RETORNO_ST_INTERNO";

    const transportistaAsignado =
        Boolean(correo?.trim()) &&
        Boolean(patente?.trim());

    const tiposTraspaso = [
        {
            key: '1',
            value: 'PACIENTE A S.TECNICO',
            text: 'PACIENTE A S.TECNICO',
        },
        {
            key: '2',
            value: 'S.TECNICO A PACIENTE',
            text: 'S.TECNICO A PACIENTE',
        },
    ];

    if (contratoMantencion?.activo === true) {
        tiposTraspaso.push({
            key: '3',
            value: 'PACIENTE A S.T. INTERNO',
            text: 'PACIENTE A S.T. INTERNO',
        });
    }

    const mostrarError = (mensaje) => {
        cambiarEstadoAlerta(true);
        cambiarAlerta({
            tipo: 'error',
            mensaje,
        });
    };

    const mostrarExito = (mensaje) => {
        cambiarEstadoAlerta(true);
        cambiarAlerta({
            tipo: 'exito',
            mensaje,
        });
    };

    const opcionesTransportistas = useMemo(() => {
        return transport
            .filter((item) => item.correo)
            .map((item) => ({
                key: item.id || item.correo,
                value: item.correo,
                text:
                    `${item.nombre || ""} ${item.apellido || ""}`.trim()
                        ? `${item.nombre || ""} ${item.apellido || ""} - ${item.correo}`
                        : item.correo,
            }));
    }, [transport]);

    const asignarTransportistaRetorno = async () => {
        if (!cabId) {
            return mostrarError(
                "No existe cabecera de traspaso seleccionada."
            );
        }

        if (!correoTransportistaTmp) {
            return mostrarError(
                "Seleccione el transportista que realizará el retiro."
            );
        }

        if (!patenteTransportistaTmp.trim()) {
            return mostrarError(
                "Ingrese la patente del vehículo."
            );
        }

        try {
            setAsignandoTransportista(true);

            // Buscar detalle asociado a la cabecera
            const qDetalle = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("cab_id", "==", cabId)
            );

            const snapDetalle = await getDocs(qDetalle);

            if (snapDetalle.empty) {
                throw new Error(
                    "El traspaso no tiene equipos asociados."
                );
            }

            const batch = writeBatch(db);
            const now = new Date();

            // =========================
            // ACTUALIZAR CABECERA
            // =========================

            batch.update(
                doc(db, "salidasCab", cabId),
                {
                    correo: correoTransportistaTmp,
                    patente:
                        patenteTransportistaTmp
                            .trim()
                            .toUpperCase(),

                    usermod: user?.email || "",
                    fechamod: now,
                }
            );

            // =========================
            // ACTUALIZAR DETALLE
            // =========================

            snapDetalle.docs.forEach((docu) => {
                batch.update(
                    doc(db, "salidas", docu.id),
                    {
                        correo: correoTransportistaTmp,
                        patente:
                            patenteTransportistaTmp
                                .trim()
                                .toUpperCase(),

                        usermod: user?.email || "",
                        fechamod: now,
                    }
                );
            });

            await batch.commit();

            // Actualizar estado local
            setCorreo(correoTransportistaTmp);

            setPatente(
                patenteTransportistaTmp
                    .trim()
                    .toUpperCase()
            );

            setModalTransportista(false);

            mostrarExito(
                "Transportista asignado correctamente."
            );

        } catch (error) {
            console.error(
                "Error asignando transportista:",
                error
            );

            mostrarError(
                error?.message ||
                "No fue posible asignar el transportista."
            );

        } finally {
            setAsignandoTransportista(false);
        }
    };

    const confirmarRetornoST = async () => {
        if (!cabId) {
            return mostrarError(
                "No existe cabecera asociada."
            );
        }

        if (!transportistaAsignado) {
            return mostrarError(
                "Debe asignar un transportista antes de confirmar."
            );
        }

        try {
            setConfirmandoDocumento(true);

            const qDetalle = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("cab_id", "==", cabId)
            );

            const snapDetalle = await getDocs(qDetalle);

            if (snapDetalle.empty) {
                throw new Error(
                    "El traspaso no tiene equipos asociados."
                );
            }

            const batch = writeBatch(db);
            const now = new Date();

            // CABECERA
            batch.update(
                doc(db, "salidasCab", cabId),
                {
                    confirmado: true,

                    // IMPORTANTE:
                    // todavía está físicamente en ST.
                    retirado: false,
                    entregado: false,

                    usermod: user?.email || "",
                    fechamod: now,
                }
            );

            // DETALLES
            snapDetalle.docs.forEach((docu) => {
                batch.update(
                    doc(db, "salidas", docu.id),
                    {
                        confirmado: true,

                        usermod: user?.email || "",
                        fechamod: now,
                    }
                );
            });

            await batch.commit();

            mostrarExito(
                "Retorno confirmado. El retiro quedó asignado al transportista."
            );

            limpiarFormulario();

            await consultarCab();

        } catch (error) {
            console.error(
                "Error confirmando retorno:",
                error
            );

            mostrarError(
                error?.message ||
                "No fue posible confirmar el retorno."
            );

        } finally {
            setConfirmandoDocumento(false);
        }
    };

    const getContratoMantencion = async () => {
        if (!users?.emp_id) return;

        const q = query(
            collection(db, 'contratos_mantencion'),
            where('emp_id', '==', users.emp_id),
            where('actual', '==', true),
            where('activo', '==', true)
        );

        const snap = await getDocs(q);

        if (snap.empty) {
            setContratoMantencion(null);
            return;
        }

        setContratoMantencion({
            id: snap.docs[0].id,
            ...snap.docs[0].data(),
        });
    };

    const getSegmentStyle = (seccion) => {
        const base = {
            background: "#ffffff",
            borderRadius: 8,
            padding: 0,
            transition: "all 0.2s ease",
            overflow: "visible",
            marginBottom: 18,
        };

        if (
            seccion === "cabecera" &&
            seccionActiva === "CABECERA" &&
            !cabeceraMinimizada
        ) {
            return {
                ...base,
                border: "2px solid #2185d0",
                boxShadow: "0 0 0 3px rgba(33,133,208,0.08)",
            };
        }

        if (
            seccion === "detalle" &&
            seccionActiva === "DETALLE"
        ) {
            return {
                ...base,
                border: "2px solid #f2711c",
                boxShadow: "0 0 0 3px rgba(242,113,28,0.08)",
            };
        }

        return {
            ...base,
            border: "1px solid #e5e9ef",
            boxShadow: "0 1px 3px rgba(9,30,66,0.08)",
        };
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const dateObj = fecha.toDate ? fecha.toDate() : new Date(fecha);
        return moment(dateObj).format('DD/MM/YYYY');
    };

    const fechaDate = (fecha) => {
        if (!fecha) return;

        if (fecha.toDate) {
            setDate(fecha.toDate());
        } else {
            setDate(new Date(fecha));
        }
    };

    const OrdenaFecha = (a, b) => {
        return (a.fechaadd?.seconds || 0) - (b.fechaadd?.seconds || 0);
    };

    const consultarCab = async () => {
        if (!users?.emp_id) return;

        try {
            const q = query(
                collection(db, 'salidasCab'),
                where('emp_id', '==', users.emp_id),
                where('confirmado', '==', false),
                where('tipmov', 'in', [4, 5, 6])
            );

            const snap = await getDocs(q);

            const data = snap.docs
                .map((docu) => ({
                    ...docu.data(),
                    id: docu.id,
                }))
                .sort(
                    (a, b) =>
                        Number(a.numdoc || 0) - Number(b.numdoc || 0)
                );

            setCabecera(data);
        } catch (error) {
            console.error('Error consultando cabeceras:', error);
            setCabecera([]);
        }
    };

    const consultarOut = async () => {
        if (!users?.emp_id || !cabId) {
            setDataSalida([]);
            return;
        }

        try {
            const q = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("cab_id", "==", cabId)
            );

            const snap = await getDocs(q);

            const docs = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            setDataSalida(
                docs.sort(OrdenaFecha)
            );

        } catch (error) {
            console.error(
                "Error consultando detalle de traspaso:",
                error
            );

            setDataSalida([]);

            mostrarError(
                error?.message ||
                "Error al consultar los equipos del traspaso"
            );
        }
    };
    const getStatus = useCallback(async () => {
        if (!users?.emp_id) return;

        try {
            const q = query(
                collection(db, 'status'),
                where('emp_id', '==', users.emp_id)
            );

            const snap = await getDocs(q);

            const data = snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }));

            setStatus(data);
        } catch (error) {
            console.error('Error obteniendo status:', error);
            setStatus([]);
        }
    }, [users?.emp_id]);

    const statusPaciente = useMemo(() => {
        if (!rut) return [];

        return status.filter(
            (item) =>
                item.r_permanente === rut &&
                item.status === 'PACIENTE'
        );
    }, [status, rut]);

    const statusST = useMemo(() => {
        if (!rut) return [];

        return status.filter(
            (item) =>
                item.r_permanente === rut &&
                item.status === 'SERVICIO TECNICO'
        );
    }, [status, rut]);

    const getSt = async () => {
        if (!users) return;

        const q = query(
            collection(db, 'proveedores'),
            where('emp_id', '==', users.emp_id),
            where('categoria', 'in', ['ST_EXTERNO'])
        );

        const snap = await getDocs(q);

        setSts(
            snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }))
        );
    };

    const stPacienteSeleccionado = useMemo(() => {
        if (!rut) return [];

        const filtrados = status.filter(
            (item) =>
                item.r_permanente === rut &&
                item.status === 'SERVICIO TECNICO' &&
                item.r_destino
        );

        const unicos = filtrados.filter(
            (item, index, self) =>
                index ===
                self.findIndex((x) => x.r_destino === item.r_destino)
        );

        return unicos.map((item) => ({
            id: item.r_destino,
            rut: item.r_destino,
            nombre: item.n_destino,
            categoria: 'ST_ORIGEN_STATUS',
            interno: item.r_destino === logisticMedSt.rut,
        }));
    }, [status, rut, logisticMedSt.rut]);

    const opcionesStDropdown = esStInterno
        ? [logisticMedSt]
        : esStAPaciente
            ? stPacienteSeleccionado
            : [logisticMedSt, ...serviciosTecnicosExternos];

    const handleSelectST = (value) => {
        setRutSt(value);

        const listaCompleta = [
            logisticMedSt,
            ...serviciosTecnicosExternos,
            ...stPacienteSeleccionado,
        ];

        const stSeleccionado = listaCompleta.find(
            (x) => String(x.rut) === String(value)
        );

        setEntidadSt(stSeleccionado?.nombre || '');
    };

    const getUsuarios = async () => {
        if (!users) return;

        const q = query(
            collection(db, 'usuarios'),
            where('emp_id', '==', users.emp_id)
        );

        const snap = await getDocs(q);

        setUsuarios(
            snap.docs.map((docu, index) => ({
                ...docu.data(),
                id: docu.id,
                id2: index + 1,
            }))
        );
    };

    const transportista = async () => {
        if (!users) return;

        const q = query(
            collection(db, 'usuarios'),
            where('emp_id', '==', users.emp_id)
        );

        const snap = await getDocs(q);

        setTransport(
            snap.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }))
        );
    };

    const addCabeceraIn = async (ev) => {
        ev.preventDefault();

        const emailRegex =
            /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

        try {
            setGuardandoCabecera(true);

            // =====================================================
            // 1. VALIDACIONES GENERALES
            // =====================================================

            if (!date) {
                return mostrarError("Seleccione una Fecha");
            }

            if (!nomTipoOut || nomTipoOut === "Selecciona Opción:") {
                return mostrarError("Seleccione un Tipo de Salida");
            }

            if (!rut || rut === "Selecciona Opción:") {
                return mostrarError("Seleccione un Rut Paciente");
            }

            if (!rutSt || rutSt === "Selecciona Opción:") {
                return mostrarError("Seleccione un Servicio Técnico");
            }

            if (!correo) {
                return mostrarError("Ingrese un correo");
            }

            if (!emailRegex.test(correo)) {
                return mostrarError("Favor ingresar un correo válido");
            }

            if (!patente) {
                return mostrarError("Ingrese Patente del Vehículo");
            }

            // =====================================================
            // 2. VALIDAR TRANSPORTISTA / USUARIO
            // =====================================================

            const existeCorreo = usuario.some(
                (u) => u.correo === correo
            );

            if (!existeCorreo) {
                return mostrarError(
                    "No existe usuario con ese correo"
                );
            }

            // =====================================================
            // 3. OBTENER NUEVO FOLIO
            // =====================================================

            const nuevoFolio = await correlativos(
                users.emp_id,
                "traspasos"
            );

            // =====================================================
            // 4. DETERMINAR TIPO DE MOVIMIENTO
            // =====================================================

            const tipMovCab =
                esStAPaciente
                    ? 4
                    : esStInterno
                        ? 6
                        : 5;

            // =====================================================
            // 5. VALIDAR DUPLICADO
            // =====================================================

            const qDuplicado = query(
                collection(db, "salidasCab"),
                where("emp_id", "==", users.emp_id),
                where("numdoc", "==", nuevoFolio),
                where("tipdoc", "==", "TRASPASOS"),
                where("rut", "==", rut),
                where("tipmov", "==", tipMovCab)
            );

            const snapDuplicado = await getDocs(qDuplicado);

            if (!snapDuplicado.empty) {
                const documento = snapDuplicado.docs[0].data();

                return mostrarError(
                    documento.confirmado
                        ? "Ya existe este documento y se encuentra confirmado"
                        : "Ya existe este documento. Falta confirmar"
                );
            }

            // =====================================================
            // 6. CREAR CABECERA
            // =====================================================

            const cabeceraCreada = await CabeceraOutDB({
                numDoc: nuevoFolio,
                tipDoc: "TRASPASOS",
                date: new Date(date),
                tipoInOut: nomTipoOut,

                rut,
                entidad,

                rutSt,
                entidadSt,

                correo,
                patente: patente.trim().toUpperCase(),

                descripcion: "",

                tipMov: tipMovCab,

                url: "",

                confirmado: false,
                entregado: false,
                retirado: true,

                observacion: "",

                userAdd: user?.email || "",
                userMod: user?.email || "",

                fechaAdd: new Date(),
                fechaMod: new Date(),

                emp_id: users.emp_id,
            });

            // =====================================================
            // 7. GUARDAR ID REAL DE LA CABECERA
            // =====================================================

            setCabId(cabeceraCreada.id);

            // =====================================================
            // 8. ACTUALIZAR ESTADO LOCAL
            // =====================================================

            setFolio(nuevoFolio);
            setConfirmar(true);
            setBtnAgregar(false);
            setBtnGuardar(true);
            setBtnNuevo(false);
            setBtnConfirmar(true);
            // visualmente pasamos desde cabecera a detalle
            setCabeceraMinimizada(true);
            setSeccionActiva("DETALLE");
            // si ya agregaste el indicador visual de sección
            // puedes dejar esta línea:
            //
            // setSeccionActiva("DETALLE");

            // =====================================================
            // 9. REFRESCAR CABECERAS PENDIENTES
            // =====================================================

            await consultarCab();

            // =====================================================
            // 10. MENSAJE
            // =====================================================

            mostrarExito(
                "Cabecera Documento guardada exitosamente"
            );

        } catch (error) {
            console.error(
                "Error guardando cabecera de traspaso:",
                error
            );

            mostrarError(
                error?.message ||
                "Error al guardar Cabecera"
            );

        } finally {
            setGuardandoCabecera(false);
        }
    };

    const limpiaFormCte = () => {
        setRut('');
        setEntidad('');
    };

    const filtrarUnicosPorRut = (data, statusFiltro) => {
        const rutUnicos = new Set();

        return data.filter((item) => {
            const rutPaciente = item.r_permanente?.trim();

            if (!rutPaciente) return false;
            if (item.status !== statusFiltro) return false;
            if (rutUnicos.has(rutPaciente)) return false;

            rutUnicos.add(rutPaciente);
            return true;
        });
    };

    const pac2 = useMemo(() => {
        return filtrarUnicosPorRut(status, 'SERVICIO TECNICO').map((d) => ({
            ...d,
            rut: d.r_permanente,
            nombre: d.n_permanente,
        }));
    }, [status]);

    const ser2 = useMemo(() => {
        return filtrarUnicosPorRut(status, 'PACIENTE').map((d) => ({
            ...d,
            rut: d.r_permanente,
            nombre: d.n_permanente,
        }));
    }, [status]);

    //Mensajes operacionale
    const mostrarReglaOperacion = ({
        icon = "info",
        titulo = "",
        mensaje = "",
        detalle = "",
        color = "#2185d0",
    }) => {

        Swal.fire({
            icon,
            title: titulo,
            html: `
            <div style="text-align:left">

                <div style="
                    background:#f4f4f4;
                    padding:12px;
                    border-radius:8px;
                    margin-bottom:15px;
                ">
                    ${mensaje}
                </div>

                ${detalle
                    ? `
                    <div style="
                        background:#f8f9fa;
                        padding:12px;
                        border-left:4px solid ${color};
                        border-radius:6px;
                    ">
                        ${detalle}
                    </div>
                `
                    : ""
                }

            </div>
        `,
            confirmButtonText: "Entendido",
            confirmButtonColor: color,
        });
    };

    const handleSelectItem = (item) => {
        if (typeof item === 'object' && item !== null) {
            setRut(item.r_permanente || item.rut || '');
            setEntidad(item.n_permanente || item.nombre || '');
        } else {
            setRut(item);

            const persona = status.find((x) => x.r_permanente === item);
            setEntidad(persona?.n_permanente || '');
        }
    };
    const convertirFechaMantencion = (valor) => {

        if (!valor) {
            return null;
        }

        if (typeof valor?.toDate === "function") {
            return valor.toDate();
        }

        const fecha = new Date(valor);

        if (Number.isNaN(fecha.getTime())) {
            return null;
        }

        return fecha;
    };

    const prepararEquipoSTInterno = async (e, item) => {

        e.preventDefault();

        if (!item) {
            return mostrarError(
                "No se ha seleccionado un equipo"
            );
        }

        // =====================================================
        // FLUJOS NORMALES
        // =====================================================

        if (!esStInterno) {

            return handleSubmit(
                e,
                item
            );
        }


        // =====================================================
        // VALIDAR COBERTURA
        // =====================================================

        const tipoCubiertoContrato =
            contratoMantencion?.tipos_cubiertos?.includes(
                item.tipo
            ) === true;


        if (!tipoCubiertoContrato) {

            return mostrarReglaOperacion({
                icon: "warning",

                titulo:
                    "Equipo fuera de contrato",

                mensaje: `
                <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                Serie: ${item.serie || "Sin serie"}
            `,

                detalle: `
                Este equipo no está cubierto por contrato de mantención.<br/><br/>

                Para enviarlo debe utilizar el tipo de traspaso:<br/><br/>

                <b>PACIENTE A S.TECNICO</b>
            `,

                color: "#db2828",
            });
        }


        setConsultandoMantencion(true);


        try {

            // =================================================
            // BUSCAR MANTENCIONES DEL EQUIPO
            // =================================================

            const qMantenciones = query(
                collection(
                    db,
                    "mantenciones"
                ),
                where(
                    "emp_id",
                    "==",
                    users.emp_id
                ),
                where(
                    "id_eq",
                    "==",
                    item.id
                )
            );


            const snapMantenciones =
                await getDocs(qMantenciones);


            const mantencionesEquipo =
                snapMantenciones.docs

                    .map((docu) => ({
                        id: docu.id,
                        ...docu.data(),
                    }))

                    .filter((m) =>
                        m.activo !== false
                    )

                    .map((m) => ({
                        ...m,

                        fechaTerminoDate:
                            convertirFechaMantencion(
                                m.fecha_termino
                            ),
                    }))

                    .filter(
                        (m) =>
                            m.fechaTerminoDate
                    )

                    .sort(
                        (a, b) =>
                            a.fechaTerminoDate.getTime() -
                            b.fechaTerminoDate.getTime()
                    );


            // =================================================
            // PRÓXIMA MANTENCIÓN
            // =================================================

            const mantencion =
                mantencionesEquipo[0] || null;


            let diasRestantes = null;

            let puedePreventiva = false;


            if (mantencion?.fechaTerminoDate) {

                const hoy = new Date();

                hoy.setHours(
                    0,
                    0,
                    0,
                    0
                );


                const fechaTermino =
                    new Date(
                        mantencion.fechaTerminoDate
                    );


                fechaTermino.setHours(
                    0,
                    0,
                    0,
                    0
                );


                diasRestantes =
                    Math.ceil(
                        (
                            fechaTermino.getTime() -
                            hoy.getTime()
                        ) /
                        (
                            1000 *
                            60 *
                            60 *
                            24
                        )
                    );


                // =================================================
                // REGLA:
                //
                // <= 7 días
                // fecha exacta
                // vencida
                //
                // permite PREVENTIVA
                // =================================================

                puedePreventiva =
                    diasRestantes <= 7;
            }


            // =================================================
            // PREPARAR MODAL
            // =================================================

            setEquipoAtencionST(item);

            setMantencionAtencionST(
                mantencion
            );

            setDiasRestantesMantencion(
                diasRestantes
            );

            setPreventivaDisponible(
                puedePreventiva
            );


            // =================================================
            // CAMBIAR MODAL
            // =================================================

            setModalEquipos(false);

            setModalAtencionST(true);


        } catch (error) {

            console.error(
                "Error consultando mantención:",
                error
            );


            mostrarError(
                "No fue posible consultar la mantención del equipo"
            );


        } finally {

            setConsultandoMantencion(false);

        }
    };

    const cerrarModalAtencionST = () => {

        setModalAtencionST(false);

        setEquipoAtencionST(null);

        setMantencionAtencionST(null);

        setDiasRestantesMantencion(null);

        setPreventivaDisponible(false);


        // Volvemos al listado de equipos

        setModalEquipos(true);
    };

    const confirmarAtencionST = async (datosAtencion) => {

        if (!equipoAtencionST) {

            return mostrarError(
                "No existe equipo seleccionado"
            );
        }


        await handleSubmit(
            null,
            equipoAtencionST,
            datosAtencion
        );


        setModalAtencionST(false);

        setEquipoAtencionST(null);

        setMantencionAtencionST(null);

        setDiasRestantesMantencion(null);

        setPreventivaDisponible(false);
    };

    const handleSubmit = async (
        e,
        item,
        datosAtencion = {}
    ) => {

        if (e?.preventDefault) {
            e.preventDefault();
        }

        if (!item) {
            return mostrarError("No se ha seleccionado un equipo");
        }

        if (!cabId) {
            return mostrarError(
                "No existe una cabecera activa para este traspaso"
            );
        }

        setGuardandoEquipo(true);

        try {
            // =====================================================
            // 1. VALIDAR DUPLICADO EN EL DOCUMENTO ACTUAL
            // =====================================================

            const existeItem = dataSalida.some(
                (docu) =>
                    docu.serie === item.serie ||
                    docu.eq_id === item.id
            );

            if (existeItem) {
                return mostrarError(
                    "Equipo ya se encuentra en este documento"
                );
            }

            // =====================================================
            // 2. VALIDAR QUE EL EQUIPO NO ESTÉ EN OTRO
            //    DOCUMENTO PENDIENTE
            // =====================================================

            const qPendienteSerie = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("serie", "==", item.serie),
                where("confirmado", "==", false)
            );

            const qPendienteId = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("eq_id", "==", item.id),
                where("confirmado", "==", false)
            );

            const [snapSerie, snapId] = await Promise.all([
                getDocs(qPendienteSerie),
                getDocs(qPendienteId),
            ]);

            if (!snapSerie.empty || !snapId.empty) {
                return mostrarError(
                    "Equipo ya se encuentra ingresado en un documento por confirmar"
                );
            }

            // =====================================================
            // 3. OBTENER STATUS FRESCO DEL EQUIPO
            // =====================================================

            const statusRef = doc(
                db,
                "status",
                item.id
            );

            const statusSnap = await getDoc(statusRef);

            if (!statusSnap.exists()) {
                return mostrarError(
                    "El equipo no posee registro de estado"
                );
            }

            const statusActual = {
                ...statusSnap.data(),
                id: statusSnap.id,
            };

            // =====================================================
            // 4. VALIDAR QUE PERTENEZCA AL PACIENTE ACTUAL
            // =====================================================

            if (
                statusActual.r_permanente &&
                statusActual.r_permanente !== rut
            ) {
                return mostrarReglaOperacion({
                    icon: "error",
                    titulo: "Equipo no pertenece al paciente",
                    mensaje: `
                    <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                    Serie: ${item.serie || "Sin serie"}
                `,
                    detalle: `
                    El equipo no se encuentra asociado actualmente
                    al paciente seleccionado.
                `,
                    color: "#db2828",
                });
            }

            // =====================================================
            // 5. VALIDAR COBERTURA DE CONTRATO
            // =====================================================

            const tipoCubiertoContrato =
                contratoMantencion?.tipos_cubiertos?.includes(
                    item.tipo
                ) === true;

            // PACIENTE -> ST INTERNO
            if (
                esStInterno &&
                !tipoCubiertoContrato
            ) {
                return mostrarReglaOperacion({
                    icon: "warning",
                    titulo: "Equipo fuera de contrato",
                    mensaje: `
                    <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                    Serie: ${item.serie || "Sin serie"}
                `,
                    detalle: `
                    Este equipo no está cubierto por contrato de mantención.<br/><br/>
                    Para enviarlo debe utilizar el tipo de traspaso:<br/><br/>
                    <b>PACIENTE A S.TECNICO</b>
                `,
                    color: "#db2828",
                });
            }

            // PACIENTE -> ST EXTERNO
            if (
                esPacienteASt &&
                tipoCubiertoContrato &&
                contratoMantencion?.activo
            ) {
                return mostrarReglaOperacion({
                    icon: "info",
                    titulo: "Equipo cubierto por contrato",
                    mensaje: `
                    <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                    Serie: ${item.serie || "Sin serie"}
                `,
                    detalle: `
                    Este equipo está cubierto por contrato de mantención.<br/><br/>
                    Para mantener la trazabilidad contractual debe utilizar:<br/><br/>
                    <b>PACIENTE A S.T. INTERNO</b>
                `,
                    color: "#2185d0",
                });
            }

            // =====================================================
            // 6. VALIDAR ESTADO ACTUAL SEGÚN MOVIMIENTO
            // =====================================================

            if (
                esStAPaciente &&
                statusActual.status !== "SERVICIO TECNICO"
            ) {
                return mostrarReglaOperacion({
                    icon: "error",
                    titulo: "Equipo no disponible",
                    mensaje: `
                    <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                    Serie: ${item.serie || "Sin serie"}
                `,
                    detalle: `
                    Este equipo no se encuentra actualmente en estado
                    <b>SERVICIO TECNICO</b>, por lo tanto no puede retornar al paciente.
                `,
                    color: "#db2828",
                });
            }

            if (
                (esPacienteASt || esStInterno) &&
                statusActual.status !== "PACIENTE"
            ) {
                return mostrarReglaOperacion({
                    icon: "error",
                    titulo: "Equipo no disponible",
                    mensaje: `
                    <b>${item.tipo || "Equipo sin tipo"}</b><br/>
                    Serie: ${item.serie || "Sin serie"}
                `,
                    detalle: `
                    Este equipo no se encuentra actualmente en estado
                    <b>PACIENTE</b>, por lo tanto no puede ser enviado a Servicio Técnico.
                `,
                    color: "#db2828",
                });
            }

            // =====================================================
            // 7. VALIDAR ST SELECCIONADO
            // =====================================================

            if (!rutSt) {
                return mostrarError(
                    "No existe Servicio Técnico seleccionado"
                );
            }

            if (!entidadSt) {
                return mostrarError(
                    "No existe nombre de Servicio Técnico seleccionado"
                );
            }

            // =====================================================
            // 8. DETERMINAR TIPO DE MOVIMIENTO
            // =====================================================

            const tipMov =
                esStAPaciente
                    ? 4
                    : esStInterno
                        ? 6
                        : 5;

            // =====================================================
            // 9. CREAR DETALLE
            // =====================================================

            const now = new Date();

            const payload = {
                numDoc: folio,
                tipDoc: "TRASPASOS",
                date: date,
                tipoInOut: nomTipoOut,

                rut,
                entidad,

                correo,
                patente,

                cab_id: cabId,

                eq_id: item.id,

                familia: item.familia || "",
                tipo: item.tipo || "",
                marca: item.marca || "",
                modelo: item.modelo || "",
                serie: item.serie || "",

                rfid: item.rfid || "",

                tipMov,

                tipo_atencion:
                    esStInterno
                        ? datosAtencion.tipoAtencion || ""
                        : "",

                observacion:
                    esStInterno
                        ? datosAtencion.observacion || ""
                        : "",

                historial: 0,

                confirmado: false,

                userAdd: user?.email || "",
                userMod: user?.email || "",

                fechaAdd: now,
                fechaMod: now,

                emp_id: users.emp_id,

                // =================================================
                // TRAZABILIDAD SERVICIO TÉCNICO
                // =================================================

                rut_st: rutSt,
                nombre_st: entidadSt,

                destino_st_tipo: esStInterno
                    ? "INTERNO"
                    : "EXTERNO",

                contrato_mantencion: esStInterno,

                tipo_cubierto_contrato:
                    tipoCubiertoContrato,

                genera_ingreso_st: esStInterno,
                ingreso_st_generado: false,

                id_ingreso_st: "",

                id_mantencion:
                    esStInterno
                        ? datosAtencion.idMantencion || ""
                        : "",

                genera_certificado:
                    esStInterno &&
                    datosAtencion.tipoAtencion === "PREVENTIVA",

                reset_mantencion:
                    esStInterno &&
                    datosAtencion.tipoAtencion === "PREVENTIVA",
            };

            await SalidasDB(payload);

            // =====================================================
            // 10. REFRESCAR DETALLE
            // =====================================================

            await consultarOut();

            // =====================================================
            // 11. LIMPIEZA UI
            // =====================================================

            setModalEquipos(false);
            setBuscadorEquipos("");

            setBtnConfirmar(false);
            setBtnNuevo(false);

            mostrarExito(
                "Item guardado correctamente"
            );

        } catch (error) {
            console.error(
                "Error guardando equipo en traspaso:",
                error
            );

            mostrarError(
                error?.message ||
                "Error al guardar item"
            );

        } finally {
            setGuardandoEquipo(false);
        }
    };

    const actualizarDocs = async () => {
        // =====================================================
        // 1. VALIDACIONES INICIALES
        // =====================================================

        if (dataSalida.length === 0) {
            return Swal.fire(
                "No hay datos por confirmar en este documento"
            );
        }

        if (!cabId) {
            return mostrarError(
                "No existe una cabecera activa para confirmar"
            );
        }

        if (!users?.emp_id) {
            return mostrarError(
                "No se pudo identificar la empresa"
            );
        }

        setConfirmandoDocumento(true);

        try {
            // Guardamos estos datos antes de limpiar el formulario
            const detalleCorreo = [...dataSalida];
            const tipoMovimientoActual = nomTipoOut;

            // =====================================================
            // 2. DEFINIR MOVIMIENTO
            // =====================================================

            const movimiento = esStAPaciente
                ? {
                    status: "TRANSITO PACIENTE",

                    origen: {
                        rut: rutSt,
                        nombre: entidadSt,
                    },

                    destino: {
                        rut,
                        nombre: entidad,
                    },

                    statusEsperado: "SERVICIO TECNICO",
                }
                : {
                    status: "TRANSITO ST",

                    origen: {
                        rut,
                        nombre: entidad,
                    },

                    destino: {
                        rut: rutSt,
                        nombre: entidadSt,
                    },

                    statusEsperado: "PACIENTE",
                };

            // =====================================================
            // 3. VALIDAR STATUS FRESCO DE TODOS LOS EQUIPOS
            // =====================================================

            const estadosActuales = await Promise.all(
                dataSalida.map(async (item) => {
                    const statusSnap = await getDoc(
                        doc(db, "status", item.eq_id)
                    );

                    if (!statusSnap.exists()) {
                        throw new Error(
                            `No existe status para la serie ${item.serie || item.eq_id}`
                        );
                    }

                    return {
                        detalle: item,
                        status: statusSnap.data(),
                    };
                })
            );

            // =====================================================
            // 4. VALIDAR QUE NO HAYA CAMBIADO LA SITUACIÓN
            // =====================================================

            for (const registro of estadosActuales) {
                const {
                    detalle,
                    status: statusActual,
                } = registro;

                if (
                    statusActual.status !==
                    movimiento.statusEsperado
                ) {
                    throw new Error(
                        `El equipo serie ${detalle.serie || "-"} ya no se encuentra en estado ${movimiento.statusEsperado}`
                    );
                }

                // r_permanente identifica al paciente propietario
                if (
                    statusActual.r_permanente &&
                    statusActual.r_permanente !== rut
                ) {
                    throw new Error(
                        `El equipo serie ${detalle.serie || "-"} ya no pertenece al paciente seleccionado`
                    );
                }
            }

            // =====================================================
            // 5. CREAR BATCH
            // =====================================================

            const batch = writeBatch(db);
            const now = new Date();

            dataSalida.forEach((item) => {
                // ===============================================
                // STATUS DEL EQUIPO
                // ===============================================

                batch.update(
                    doc(db, "status", item.eq_id),
                    {
                        status: movimiento.status,

                        r_origen:
                            movimiento.origen.rut,

                        n_origen:
                            movimiento.origen.nombre,

                        r_destino:
                            movimiento.destino.rut,

                        n_destino:
                            movimiento.destino.nombre,

                        fechamod: now,
                    }
                );

                // IMPORTANTE:
                // NO modificamos:
                //
                // r_permanente
                // n_permanente
                //
                // porque representan a quién pertenece
                // permanentemente el equipo.

                // ===============================================
                // DETALLE SALIDA
                // ===============================================

                batch.update(
                    doc(db, "salidas", item.id),
                    {
                        confirmado: true,
                        usermod: user?.email || "",
                        fechamod: now,
                    }
                );
            });

            // =====================================================
            // 6. CONFIRMAR CABECERA
            // =====================================================

            batch.update(
                doc(db, "salidasCab", cabId),
                {
                    confirmado: true,
                    usermod: user?.email || "",
                    fechamod: now,
                }
            );

            // =====================================================
            // 7. CONFIRMAR TODO ATÓMICAMENTE
            // =====================================================

            await batch.commit();

            // =====================================================
            // 8. ENVIAR CORREOS
            // =====================================================

            if (
                tipoMovimientoActual ===
                "S.TECNICO A PACIENTE" ||
                tipoMovimientoActual ===
                "PACIENTE A S.TECNICO" ||
                tipoMovimientoActual ===
                "PACIENTE A S.T. INTERNO"
            ) {
                const mensaje =
                    cuerpoCorreo(detalleCorreo);

                await Promise.allSettled(
                    alertaSalida.map((destino) =>
                        EnviarCorreo(
                            destino.correo,
                            "Alerta Salida de Bodega",
                            mensaje
                        )
                    )
                );
            }

            // =====================================================
            // 9. MENSAJE
            // =====================================================

            mostrarExito(
                "Traspaso confirmado correctamente."
            );

            // =====================================================
            // 10. LIMPIAR Y RECARGAR
            // =====================================================

            limpiarFormulario();

            setCabeceraMinimizada(false);
            setSeccionActiva("CABECERA");

            await Promise.all([
                consultarCab(),
                getStatus(),
                consultarUltimosConfirmados(),
            ]);

        } catch (error) {
            console.error(
                "Error confirmando traspaso:",
                error
            );

            mostrarError(
                error?.message ||
                "Error al actualizar documentos"
            );

        } finally {
            setConfirmandoDocumento(false);
        }
    };

    const handleDelete = (itemId) => {
        setItemDelete(itemId);
        setShowConfirmation(true);
    };

    const cancelDelete = () => {
        setShowConfirmation(false);
        setItemDelete(null);
    };

    const borrarItem = async () => {
        if (!itemDelete) return;

        try {
            await deleteDoc(doc(db, 'salidas', itemDelete));
            await consultarOut();

            mostrarExito('Item eliminado exitosamente.');
        } catch (error) {
            console.error('Error al eliminar item:', error);
            mostrarError(error?.message || 'Error al eliminar item');
        } finally {
            setShowConfirmation(false);
            setItemDelete(null);
        }
    };

    const handleAnular = (itemId) => {
        setItemAnular(itemId);
        setShowConfirmationAnular(true);
    };

    const cancelAnular = () => {
        setShowConfirmationAnular(false);
        setItemAnular(null);
    };

    const limpiarFormulario = () => {
        setFolio('');
        setDate(new Date());
        setNomTipoOut('');
        setRut('');
        setEntidad('');
        setRutSt('');
        setEntidadSt('');
        setCorreo('');
        setPatente('');
        setConfirmar(false);
        setBtnGuardar(false);
        setBtnAgregar(true);
        setBtnConfirmar(true);
        setBtnNuevo(true);
        setDataSalida([]);
        setCabId('');
        setCabeceraMinimizada(false);
        setModalEquipos(false);
        setBuscadorEquipos('');
        setOrigenTraspaso("");

        setModalTransportista(false);
        setCorreoTransportistaTmp("");
        setPatenteTransportistaTmp("");

    };

    const anular = async () => {
        if (!itemAnular) {
            return mostrarError(
                "No existe un documento seleccionado para anular"
            );
        }

        if (!users?.emp_id) {
            return mostrarError(
                "No se pudo identificar la empresa"
            );
        }

        try {
            const q = query(
                collection(db, "salidas"),
                where("emp_id", "==", users.emp_id),
                where("cab_id", "==", itemAnular)
            );

            const snap = await getDocs(q);

            const batch = writeBatch(db);
            const now = new Date();

            // =====================================================
            // 1. MARCAR CABECERA COMO ANULADA
            // =====================================================

            batch.update(
                doc(db, "salidasCab", itemAnular),
                {
                    tipmov: 3,
                    usermod: user?.email || "",
                    fechamod: now,
                }
            );

            // =====================================================
            // 2. ELIMINAR DETALLES PENDIENTES
            // =====================================================

            snap.docs.forEach((detalleDoc) => {
                batch.delete(
                    doc(db, "salidas", detalleDoc.id)
                );
            });

            // =====================================================
            // 3. EJECUTAR TODO EN UN SOLO BATCH
            // =====================================================

            await batch.commit();

            mostrarExito(
                "Documento anulado correctamente"
            );

            // =====================================================
            // 4. LIMPIAR UI
            // =====================================================

            setShowConfirmationAnular(false);
            setItemAnular(false);
            limpiarFormulario();
            setSeccionActiva("CABECERA");
            await Promise.all([
                consultarCab(),
                consultarUltimosConfirmados(),
            ]);

        } catch (error) {
            console.error(
                "Error anulando documento:",
                error
            );

            mostrarError(
                error?.message ||
                "Error al anular el documento"
            );
        }
    };

    // const cuerpoCorreo = (data = []) => {
    //     if (!data.length) return '';

    //     const { tipoinout, numdoc, tipdoc, entidad, rut } = data[0];

    //     const equiposHTML = data
    //         .map(
    //             (item, index) => `
    //       <tr>
    //           <td style="padding:8px; border:1px solid #dcdcdc; text-align:center;">${index + 1}</td>
    //           <td style="padding:8px; border:1px solid #dcdcdc;">${item.tipo}</td>
    //           <td style="padding:8px; border:1px solid #dcdcdc;">${item.marca}</td>
    //           <td style="padding:8px; border:1px solid #dcdcdc;">${item.modelo}</td>
    //           <td style="padding:8px; border:1px solid #dcdcdc;">${item.serie}</td>
    //       </tr>
    //     `
    //         )
    //         .join('');

    //     return `
    //   <div style="background:#f4f6f8;padding:30px;font-family:Arial,sans-serif;color:#333">
    //     <div style="max-width:800px;margin:auto;background:white;border-radius:10px;overflow:hidden;border:1px solid #dcdcdc;">
    //       <div style="background:#008080;color:white;padding:20px;text-align:center;">
    //         <h2 style="margin:0;">Salida de Bodega</h2>
    //         <p style="margin-top:8px;">Equipos en tránsito</p>
    //       </div>
    //       <div style="padding:25px;">
    //         <h3 style="margin-top:0;color:#008080;">Información del Documento</h3>
    //         <table width="100%" style="border-collapse:collapse;margin-bottom:25px;">
    //           <tbody>
    //             <tr><td><strong>Tipo Salida:</strong></td><td>${tipoinout}</td></tr>
    //             <tr><td><strong>N° Documento:</strong></td><td>${numdoc}</td></tr>
    //             <tr><td><strong>Tipo Documento:</strong></td><td>${tipdoc}</td></tr>
    //             <tr><td><strong>Nombre:</strong></td><td>${entidad}</td></tr>
    //             <tr><td><strong>Rut:</strong></td><td>${rut}</td></tr>
    //           </tbody>
    //         </table>
    //         <h3 style="color:#008080;margin-bottom:15px;">Equipos trasladados</h3>
    //         <table width="100%" style="border-collapse:collapse;font-size:14px;">
    //           <thead>
    //             <tr style="background:#f1f1f1;">
    //               <th style="padding:10px;border:1px solid #dcdcdc;">#</th>
    //               <th style="padding:10px;border:1px solid #dcdcdc;">Tipo</th>
    //               <th style="padding:10px;border:1px solid #dcdcdc;">Marca</th>
    //               <th style="padding:10px;border:1px solid #dcdcdc;">Modelo</th>
    //               <th style="padding:10px;border:1px solid #dcdcdc;">Serie</th>
    //             </tr>
    //           </thead>
    //           <tbody>${equiposHTML}</tbody>
    //         </table>
    //         <div style="margin-top:30px;padding:15px;background:#fff8e1;border-left:4px solid #ffb300;font-size:14px;">
    //           Los equipos se encuentran en tránsito y pendientes de confirmación por el destinatario.
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // `;
    // };

    const cuerpoCorreo = (data = []) => {
        if (!data.length) return "";

        const {
            tipoinout,
            numdoc,
            tipdoc,
            entidad,
            rut,
        } = data[0];

        const equiposHTML = data
            .map(
                (item, index) => `
            <tr>
                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        text-align:center;
                        font-size:13px;
                        color:#555;
                    "
                >
                    ${index + 1}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        font-weight:600;
                        color:#1b1c1d;
                    "
                >
                    ${item.tipo || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        color:#555;
                    "
                >
                    ${item.marca || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:14px;
                        color:#555;
                    "
                >
                    ${item.modelo || "-"}
                </td>

                <td
                    style="
                        padding:12px 8px;
                        border-bottom:1px solid #ececec;
                        font-size:13px;
                        color:#008080;
                        font-weight:600;
                        white-space:nowrap;
                    "
                >
                    ${item.serie || "-"}
                </td>
            </tr>
        `
            )
            .join("");

        return `
    <div
        style="
            width:100%;
            background:#f4f6f8;
            padding:20px 10px;
            font-family:Arial,sans-serif;
            color:#333;
            box-sizing:border-box;
        "
    >

        <table
            width="100%"
            cellpadding="0"
            cellspacing="0"
            border="0"
            style="
                max-width:640px;
                margin:auto;
                background:#ffffff;
                border-radius:14px;
                overflow:hidden;
                border:1px solid #e5e7eb;
                box-shadow:0 4px 18px rgba(0,0,0,0.05);
            "
        >

            <!-- HEADER -->

            <tr>
                <td
                    style="
                        background:linear-gradient(135deg,#008080,#00a3a3);
                        padding:30px 25px;
                        text-align:center;
                        color:white;
                    "
                >

                    <div
                        style="
                            font-size:28px;
                            margin-bottom:10px;
                        "
                    >
                        🚚
                    </div>

                    <h1
                        style="
                            margin:0;
                            font-size:24px;
                            font-weight:700;
                            line-height:1.2;
                        "
                    >
                        Salida de Bodega
                    </h1>

                    <p
                        style="
                            margin:10px 0 0 0;
                            opacity:0.95;
                            font-size:15px;
                        "
                    >
                        Equipos en tránsito
                    </p>

                </td>
            </tr>

            <!-- BODY -->

            <tr>
                <td style="padding:25px;">

                    <!-- INFO DOCUMENTO -->

                    <div
                        style="
                            background:#f8fafc;
                            border:1px solid #e5e7eb;
                            border-radius:12px;
                            padding:18px;
                            margin-bottom:25px;
                        "
                    >

                        <div
                            style="
                                font-size:17px;
                                font-weight:700;
                                color:#008080;
                                margin-bottom:15px;
                            "
                        >
                            Información del Documento
                        </div>

                        <table
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                        >
                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Tipo Salida
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${tipoinout || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    N° Documento
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${numdoc || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Tipo Documento
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${tipdoc || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Entidad
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${entidad || "-"}
                                </td>
                            </tr>

                            <tr>
                                <td style="padding:6px 0; color:#666;">
                                    Rut
                                </td>

                                <td
                                    style="
                                        padding:6px 0;
                                        text-align:right;
                                        font-weight:600;
                                        color:#1b1c1d;
                                    "
                                >
                                    ${rut || "-"}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <!-- EQUIPOS -->

                    <div
                        style="
                            font-size:17px;
                            font-weight:700;
                            color:#008080;
                            margin-bottom:15px;
                        "
                    >
                        Equipos trasladados
                    </div>

                    <div
                        style="
                            overflow-x:auto;
                            border:1px solid #ececec;
                            border-radius:12px;
                        "
                    >

                        <table
                            width="100%"
                            cellpadding="0"
                            cellspacing="0"
                            border="0"
                            style="
                                border-collapse:collapse;
                                min-width:520px;
                            "
                        >

                            <thead>

                                <tr
                                    style="
                                        background:#f8fafc;
                                    "
                                >

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:center;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        #
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Tipo
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Marca
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Modelo
                                    </th>

                                    <th
                                        style="
                                            padding:14px 8px;
                                            text-align:left;
                                            font-size:13px;
                                            color:#666;
                                            border-bottom:1px solid #ececec;
                                        "
                                    >
                                        Serie
                                    </th>

                                </tr>

                            </thead>

                            <tbody>
                                ${equiposHTML}
                            </tbody>

                        </table>

                    </div>

                    <!-- ALERTA -->

                    <div
                        style="
                            margin-top:25px;
                            background:#fff8e1;
                            border-left:5px solid #ffb300;
                            border-radius:10px;
                            padding:16px;
                            font-size:14px;
                            line-height:1.5;
                            color:#6b5b00;
                        "
                    >
                        <strong>Importante:</strong><br/>
                        Los equipos se encuentran actualmente en tránsito y
                        pendientes de confirmación por el destinatario.
                    </div>

                </td>
            </tr>

            <!-- FOOTER -->

            <tr>
                <td
                    style="
                        background:#fafafa;
                        border-top:1px solid #ececec;
                        padding:18px;
                        text-align:center;
                        font-size:12px;
                        color:#888;
                    "
                >
                    Este correo fue generado automáticamente por LogisticMed.
                </td>
            </tr>

        </table>

    </div>
    `;
    };

    const nuevo = () => {
        limpiarFormulario();
    };
    const consultarUltimosConfirmados = async () => {
        if (!users?.emp_id) {
            setUltimosConfirmados([]);
            return;
        }

        try {
            const q = query(
                collection(db, "salidasCab"),
                where("emp_id", "==", users.emp_id),
                where("tipdoc", "==", "TRASPASOS"),
                where("confirmado", "==", true)
            );

            const snap = await getDocs(q);

            const documentos = snap.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }));

            documentos.sort((a, b) => {
                const fechaA =
                    a.fechamod?.toDate?.() ||
                    a.fechaadd?.toDate?.() ||
                    a.date?.toDate?.() ||
                    new Date(0);

                const fechaB =
                    b.fechamod?.toDate?.() ||
                    b.fechaadd?.toDate?.() ||
                    b.date?.toDate?.() ||
                    new Date(0);

                return fechaB - fechaA;
            });

            setUltimosConfirmados(
                documentos.slice(0, 5)
            );

        } catch (error) {
            console.error(
                "Error consultando últimos traspasos confirmados:",
                error
            );

            setUltimosConfirmados([]);
        }
    };
    const obtenerDetalleDocumento = async (cabId) => {
        const q = query(
            collection(db, "salidas"),
            where("emp_id", "==", users.emp_id),
            where("cab_id", "==", cabId)
        );

        const snap = await getDocs(q);

        return snap.docs.map((docu, index) => ({
            ...docu.data(),
            id: docu.id,
            id2: index + 1,
        }));
    };

    const verPDFDocumento = async (cab) => {
        setCargandoPDFId(cab.id);

        try {
            const detalle = await obtenerDetalleDocumento(cab.id);

            setCabeceraPDF(cab);
            setDetallePDF(detalle);
            setModalPDF(true);
        } catch (error) {
            mostrarError("Error al cargar PDF");
        } finally {
            setCargandoPDFId(null);
        }
    };

    useEffect(() => {
        if (!users) return;

        const cargarDatos = async () => {
            limpiarFormulario();

            await Promise.allSettled([
                consultarCab(),
                transportista(),
                getUsuarios(),
                getSt(),
                getAlertasSalidas(),
                getStatus(),
                getContratoMantencion(),
                consultarUltimosConfirmados()
            ]);
        };

        cargarDatos();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users]);

    useEffect(() => {
        if (users?.emp_id && cabId) {
            consultarOut();
        } else {
            setDataSalida([]);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [users?.emp_id, cabId]);

    const getAlertasSalidas = async () => {
        if (!users) return;

        const traerAlertas = collection(db, 'usuariosalertas');
        const dato = query(traerAlertas, where('emp_id', '==', users.emp_id));
        const data = await getDocs(dato);

        setAlertasalida(
            data.docs.map((docu) => ({
                ...docu.data(),
                id: docu.id,
            }))
        );
    };

    const equiposDisponibles =
        esPacienteASt || esStInterno ? statusPaciente : statusST;

    const equiposDisponiblesFiltrados = equiposDisponibles.filter((item) => {

        // =====================================================
        // 1. NO MOSTRAR EQUIPOS YA AGREGADOS AL DOCUMENTO
        // =====================================================

        const yaAgregado = dataSalida.some(
            (detalle) =>
                detalle.eq_id === item.id ||
                (
                    detalle.serie &&
                    item.serie &&
                    detalle.serie === item.serie
                )
        );

        if (yaAgregado) {
            return false;
        }

        // =====================================================
        // 2. FILTRO DEL BUSCADOR
        // =====================================================

        const q = buscadorEquipos
            .trim()
            .toLowerCase();

        return (
            String(item.serie || "")
                .toLowerCase()
                .includes(q) ||

            String(item.tipo || "")
                .toLowerCase()
                .includes(q) ||

            String(item.familia || "")
                .toLowerCase()
                .includes(q) ||

            String(item.marca || "")
                .toLowerCase()
                .includes(q) ||

            String(item.modelo || "")
                .toLowerCase()
                .includes(q)
        );
    });
    const abrirModalTransportista = () => {
        // Si ya tenía transportista asignado,
        // carga los valores actuales para poder modificarlos.
        setCorreoTransportistaTmp(correo || "");
        setPatenteTransportistaTmp(patente || "");

        // Abre el modal
        setModalTransportista(true);
    };


    return (
        <>
            {/* =====================================================
            SPINNERS
        ===================================================== */}

            <Spinner
                loading={guardandoCabecera}
                mensaje="Guardando traspaso..."
            />

            <Spinner
                loading={confirmandoDocumento}
                mensaje="Confirmando documento..."
            />

            {/* =====================================================
            FONDO PÁGINA
        ===================================================== */}

            <div
                style={{
                    minHeight: "100vh",
                    background: "#f8fafc",
                    paddingBottom: 40,
                }}
            >
                <Container
                    style={{
                        maxWidth: 1400,
                        paddingTop: 24,
                    }}
                >
                    {/* =================================================
                    HEADER PÁGINA
                ================================================= */}

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 16,
                            marginBottom: 22,
                            flexWrap: "wrap",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 14,
                            }}
                        >
                            <div
                                style={{
                                    width: 48,
                                    height: 48,
                                    borderRadius: 8,
                                    background: "#e8f7f8",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <Icon
                                    name="exchange"
                                    size="large"
                                    style={{
                                        margin: 0,
                                        color: "#0d9da5",
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 24,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.2,
                                    }}
                                >
                                    Traspasos de Equipos
                                </div>

                                <div
                                    style={{
                                        color: "#6b778c",
                                        fontSize: 13,
                                        marginTop: 4,
                                    }}
                                >
                                    Traslado de equipos entre Pacientes y
                                    Servicio Técnico
                                </div>
                            </div>
                        </div>

                        {confirmar && folio && (
                            <Label
                                size="large"
                                style={{
                                    background: "#e8f7f8",
                                    color: "#0d9da5",
                                    border: "1px solid #b8e3e6",
                                    borderRadius: 6,
                                }}
                            >
                                <Icon name="file alternate outline" />
                                Traspaso N° {folio}
                            </Label>
                        )}
                    </div>

                    {/* =================================================
                    CABECERA DOCUMENTO
                ================================================= */}

                    <Segment
                        style={getSegmentStyle("cabecera")}
                        onClick={() => {
                            if (!cabeceraMinimizada) {
                                setSeccionActiva("CABECERA");
                            }
                        }}
                    >
                        {/* HEADER CARD */}

                        <div
                            style={{
                                minHeight: 54,
                                padding: "14px 18px",
                                borderBottom: cabeceraMinimizada
                                    ? "none"
                                    : "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                gap: 10,
                                flexWrap: "wrap",
                                background: "#ffffff",
                                borderRadius: cabeceraMinimizada
                                    ? 8
                                    : "8px 8px 0 0",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                }}
                            >
                                <Icon
                                    name="file alternate outline"
                                    style={{
                                        color: "#2185d0",
                                        fontSize: 17,
                                    }}
                                />

                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 700,
                                        color: "#253858",
                                    }}
                                >
                                    Cabecera del Documento
                                </span>

                                {seccionActiva === "CABECERA" &&
                                    !cabeceraMinimizada && (
                                        <Label
                                            size="tiny"
                                            style={{
                                                background: "#eaf4fb",
                                                color: "#2185d0",
                                                border:
                                                    "1px solid #b8d7f0",
                                            }}
                                        >
                                            Editando
                                        </Label>
                                    )}
                            </div>

                            {confirmar && (
                                <Button
                                    size="mini"
                                    basic
                                    type="button"
                                    onClick={(e) => {
                                        e.stopPropagation();

                                        setCabeceraMinimizada(
                                            !cabeceraMinimizada
                                        );
                                    }}
                                    icon
                                    labelPosition="left"
                                >
                                    <Icon
                                        name={
                                            cabeceraMinimizada
                                                ? "angle down"
                                                : "angle up"
                                        }
                                    />

                                    {cabeceraMinimizada
                                        ? "Ver cabecera"
                                        : "Minimizar"}
                                </Button>
                            )}
                        </div>

                        {/* =============================================
                        CABECERA MINIMIZADA
                    ============================================= */}

                        {cabeceraMinimizada ? (
                            <div
                                style={{
                                    padding: "12px 18px",
                                    background: "#f8fafc",
                                    borderRadius: "0 0 8px 8px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        flexWrap: "wrap",
                                    }}
                                >
                                    <Label
                                        style={{
                                            background: "#e8f7f8",
                                            color: "#0d9da5",
                                            border:
                                                "1px solid #b8e3e6",
                                        }}
                                    >
                                        <Icon name="file" />
                                        TRASPASOS
                                    </Label>

                                    <strong
                                        style={{
                                            color: "#253858",
                                        }}
                                    >
                                        N° {folio}
                                    </strong>

                                    <span
                                        style={{
                                            color: "#5e6c84",
                                        }}
                                    >
                                        {nomTipoOut} | {rut} - {entidad}
                                    </span>

                                    {esRetornoST && (
                                        <Label
                                            basic
                                            color="blue"
                                            size="mini"
                                        >
                                            <Icon name="exchange" />
                                            RETORNO S.T.
                                        </Label>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <Form
                                style={{
                                    padding: 18,
                                }}
                                onFocusCapture={() =>
                                    setSeccionActiva("CABECERA")
                                }
                            >
                                {/* =====================================
                                AVISO RETORNO ST
                            ===================================== */}

                                {esRetornoST && (
                                    <Message info icon>
                                        <Icon name="exchange" />

                                        <Message.Content>
                                            <Message.Header>
                                                Retorno automático desde
                                                Servicio Técnico
                                            </Message.Header>

                                            La mantención de este equipo
                                            fue finalizada. Asigne el
                                            transportista que realizará el
                                            retiro desde Servicio Técnico y
                                            luego confirme el documento.
                                        </Message.Content>
                                    </Message>
                                )}

                                {/* =====================================
                                FILA 1
                            ===================================== */}

                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>N° de Traspaso</label>

                                        <Input
                                            disabled
                                            type="number"
                                            name="NumDoc"
                                            value={folio || ""}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Fecha Salida</label>

                                        <div className="ui fluid input">
                                            <DatePicker
                                                selected={date}
                                                openToDate={date}
                                                onChange={(fecha) => {
                                                    if (!fecha) return;

                                                    const ahora =
                                                        new Date();

                                                    fecha.setHours(
                                                        ahora.getHours(),
                                                        ahora.getMinutes(),
                                                        ahora.getSeconds(),
                                                        ahora.getMilliseconds()
                                                    );

                                                    setDate(
                                                        new Date(fecha)
                                                    );
                                                }}
                                                locale={es}
                                                dateFormat="dd/MM/yyyy"
                                                todayButton="Hoy"
                                                shouldCloseOnSelect
                                                placeholderText="Seleccione fecha"
                                                disabled={
                                                    esRetornoST ||
                                                    confirmar
                                                }
                                                minDate={fechaMinima}
                                                maxDate={fechaMaxima}
                                                wrapperClassName="datePickerFullWidth"
                                            />
                                        </div>
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Tipo Traspaso</label>

                                        <Dropdown
                                            fluid
                                            selection
                                            search
                                            disabled={
                                                esRetornoST ||
                                                confirmar ||
                                                dataSalida.length > 0 ||
                                                guardandoCabecera
                                            }
                                            options={tiposTraspaso}
                                            value={nomTipoOut}
                                            placeholder="Seleccione tipo"
                                            onChange={(e, { value }) => {
                                                setNomTipoOut(value);

                                                if (
                                                    value ===
                                                    "PACIENTE A LOGISTICMED ST"
                                                ) {
                                                    setRutSt(
                                                        logisticMedSt.rut
                                                    );

                                                    setEntidadSt(
                                                        logisticMedSt.nombre
                                                    );
                                                } else {
                                                    setRutSt("");
                                                    setEntidadSt("");
                                                }
                                            }}
                                        />
                                    </Form.Field>
                                </Form.Group>

                                {/* =====================================
                                FILA 2
                            ===================================== */}

                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>Rut Paciente</label>

                                        <BuscadorInput
                                            items={
                                                nomTipoOut ===
                                                    "S.TECNICO A PACIENTE"
                                                    ? pac2
                                                    : ser2
                                            }
                                            onSelectItem={
                                                handleSelectItem
                                            }
                                            limpiaFormCte={
                                                limpiaFormCte
                                            }
                                            confirmar={
                                                confirmar ||
                                                esRetornoST
                                            }
                                            rut={rut}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>Nombre Paciente</label>

                                        <Input
                                            value={entidad}
                                            readOnly
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>
                                            Rut Servicio Técnico
                                        </label>

                                        <Dropdown
                                            fluid
                                            selection
                                            search
                                            placeholder="Seleccione ST"
                                            value={rutSt}
                                            disabled={
                                                esRetornoST ||
                                                confirmar
                                            }
                                            options={[
                                                ...opcionesStDropdown,

                                                rutSt &&
                                                    !opcionesStDropdown.some(
                                                        (st) =>
                                                            st.rut ===
                                                            rutSt
                                                    )
                                                    ? {
                                                        id: rutSt,
                                                        rut: rutSt,
                                                        nombre:
                                                            entidadSt ||
                                                            "Servicio Técnico",
                                                    }
                                                    : null,
                                            ]
                                                .filter(Boolean)
                                                .map((st) => ({
                                                    key: st.id,
                                                    value: st.rut,
                                                    text: `${st.rut} - ${st.nombre}`,
                                                }))}
                                            onChange={(e, data) =>
                                                handleSelectST(
                                                    data.value
                                                )
                                            }
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>
                                            Servicio Técnico
                                        </label>

                                        <Input
                                            value={entidadSt || ""}
                                            readOnly
                                        />
                                    </Form.Field>
                                </Form.Group>

                                {/* =====================================
                                FILA 3
                            ===================================== */}

                                <Form.Group widths="equal">
                                    <Form.Field>
                                        <label>
                                            Correo Transportista
                                        </label>

                                        <Dropdown
                                            fluid
                                            selection
                                            search
                                            disabled={
                                                esRetornoST ||
                                                confirmar
                                            }
                                            placeholder="Seleccione transportista"
                                            value={correo || ""}
                                            onChange={(
                                                e,
                                                { value }
                                            ) =>
                                                setCorreo(value)
                                            }
                                            options={transport.map(
                                                (d) => ({
                                                    key: d.id,
                                                    text:
                                                        d.correo ||
                                                        "",
                                                    value:
                                                        d.correo ||
                                                        "",
                                                })
                                            )}
                                        />
                                    </Form.Field>

                                    <Form.Field>
                                        <label>
                                            Patente Vehículo
                                        </label>

                                        <Input
                                            disabled={
                                                esRetornoST ||
                                                confirmar
                                            }
                                            type="text"
                                            placeholder="Ej: ABCD12"
                                            name="patente"
                                            value={patente}
                                            onChange={(ev) =>
                                                setPatente(
                                                    ev.target.value.toUpperCase()
                                                )
                                            }
                                        />
                                    </Form.Field>
                                </Form.Group>

                                {/* =====================================
                                BOTONES CABECERA
                            ===================================== */}

                                <div
                                    style={{
                                        display: "flex",
                                        gap: 10,
                                        justifyContent:
                                            "flex-end",
                                        flexWrap: "wrap",
                                        paddingTop: 4,
                                    }}
                                >
                                    {esRetornoST && (
                                        <Button
                                            color="blue"
                                            type="button"
                                            onClick={
                                                abrirModalTransportista
                                            }
                                            icon
                                            labelPosition="left"
                                        >
                                            <Icon name="truck" />

                                            {transportistaAsignado
                                                ? "Cambiar transportista"
                                                : "Asignar transportista"}
                                        </Button>
                                    )}

                                    <Button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            addCabeceraIn(e);
                                        }}
                                        disabled={
                                            esRetornoST ||
                                            btnGuardar
                                        }
                                        icon
                                        labelPosition="left"
                                        style={{
                                            background: "#0d9da5",
                                            color: "#ffffff",
                                        }}
                                    >
                                        <Icon name="save" />
                                        Guardar Cabecera
                                    </Button>

                                    <Button
                                        basic
                                        color="blue"
                                        type="button"
                                        onClick={() => {
                                            setSeccionActiva(
                                                "CABECERA"
                                            );
                                            nuevo();
                                        }}
                                        disabled={btnNuevo}
                                        icon
                                        labelPosition="left"
                                    >
                                        <Icon name="add" />
                                        Nuevo
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Segment>

                    {/* =================================================
                    EQUIPOS DEL TRASPASO
                ================================================= */}

                    <Segment
                        style={getSegmentStyle("detalle")}
                        onClick={() => {
                            if (confirmar) {
                                setSeccionActiva("DETALLE");
                            }
                        }}
                    >
                        {/* HEADER CARD */}

                        <div
                            style={{
                                minHeight: 54,
                                padding: "14px 18px",
                                borderBottom:
                                    "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                alignItems: "center",
                                gap: 12,
                                flexWrap: "wrap",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "wrap",
                                }}
                            >
                                <Icon
                                    name="list alternate outline"
                                    style={{
                                        color: "#f2711c",
                                        fontSize: 17,
                                    }}
                                />

                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 700,
                                        color: "#253858",
                                    }}
                                >
                                    Equipos del Traspaso
                                </span>

                                {seccionActiva === "DETALLE" &&
                                    confirmar && (
                                        <Label
                                            size="tiny"
                                            style={{
                                                background:
                                                    "#fff3eb",
                                                color: "#f2711c",
                                                border:
                                                    "1px solid #f7c7a7",
                                            }}
                                        >
                                            Agregando equipos
                                        </Label>
                                    )}

                                {dataSalida.length > 0 && (
                                    <Label
                                        basic
                                        size="tiny"
                                        style={{
                                            color: "#6b778c",
                                        }}
                                    >
                                        {dataSalida.length}{" "}
                                        {dataSalida.length === 1
                                            ? "equipo"
                                            : "equipos"}
                                    </Label>
                                )}
                            </div>

                            {esRetornoST && (
                                <Label
                                    basic
                                    color="blue"
                                    size="small"
                                >
                                    <Icon name="lock" />
                                    Equipo proveniente de S.T.
                                </Label>
                            )}
                        </div>

                        <div
                            style={{
                                padding: 18,
                            }}
                        >
                            {/* =========================================
    AGREGAR EQUIPOS
========================================= */}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginBottom: 14,
                                }}
                            >
                                <Button
                                    type="button"
                                    icon
                                    labelPosition="left"
                                    disabled={
                                        btnAgregar ||
                                        guardandoEquipo ||
                                        consultandoMantencion ||
                                        esRetornoST
                                    }
                                    onClick={(e) => {
                                        e.stopPropagation();

                                        setBuscadorEquipos("");
                                        setModalEquipos(true);
                                    }}
                                    style={{
                                        background: "#0d9da5",
                                        color: "#ffffff",
                                        borderRadius: 6,
                                    }}
                                >
                                    <Icon name="plus" />
                                    Agregar Equipo
                                </Button>
                            </div>

                            {/* =========================================
                            TABLA EQUIPOS
                        ========================================= */}

                            <div
                                style={{
                                    maxHeight: 420,
                                    overflowY: "auto",
                                    overflowX: "auto",
                                    border:
                                        "1px solid #e5e9ef",
                                    borderRadius: 6,
                                }}
                            >
                                <Table
                                    celled
                                    compact="very"
                                    unstackable
                                    style={{
                                        tableLayout:
                                            "fixed",
                                        width: "100%",
                                        minWidth: 700,
                                        margin: 0,
                                    }}
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell
                                                width={1}
                                                textAlign="center"
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                N°
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                width={8}
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Equipo
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                width={4}
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                N° Serie
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                width={2}
                                                textAlign="center"
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                {esRetornoST
                                                    ? "Estado"
                                                    : "Acción"}
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {dataSalida.length ===
                                            0 ? (
                                            <Table.Row>
                                                <Table.Cell
                                                    colSpan="4"
                                                    textAlign="center"
                                                    style={{
                                                        padding:
                                                            "26px 10px",
                                                        color:
                                                            "#6b778c",
                                                    }}
                                                >
                                                    <Icon
                                                        name="boxes"
                                                        style={{
                                                            color:
                                                                "#a5adba",
                                                        }}
                                                    />

                                                    No hay equipos
                                                    agregados al
                                                    documento.
                                                </Table.Cell>
                                            </Table.Row>
                                        ) : (
                                            dataSalida.map(
                                                (
                                                    item,
                                                    index
                                                ) => (
                                                    <Table.Row
                                                        key={
                                                            item.id ??
                                                            item.eq_id
                                                        }
                                                    >
                                                        <Table.Cell
                                                            textAlign="center"
                                                        >
                                                            {index +
                                                                1}
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                    flexDirection:
                                                                        "column",
                                                                    gap: 2,
                                                                }}
                                                            >
                                                                <strong
                                                                    style={{
                                                                        color:
                                                                            "#253858",
                                                                    }}
                                                                >
                                                                    {
                                                                        item.tipo
                                                                    }
                                                                </strong>

                                                                <span
                                                                    style={{
                                                                        color:
                                                                            "#6b778c",
                                                                        fontSize: 12,
                                                                    }}
                                                                >
                                                                    {
                                                                        item.marca
                                                                    }
                                                                    {item.modelo
                                                                        ? ` / ${item.modelo}`
                                                                        : ""}
                                                                </span>
                                                            </div>
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            <strong>
                                                                {
                                                                    item.serie
                                                                }
                                                            </strong>
                                                        </Table.Cell>

                                                        <Table.Cell
                                                            textAlign="center"
                                                        >
                                                            {esRetornoST ? (
                                                                <Label
                                                                    basic
                                                                    color="blue"
                                                                    size="mini"
                                                                >
                                                                    <Icon name="lock" />
                                                                    Vinculado
                                                                </Label>
                                                            ) : (
                                                                <Button
                                                                    icon
                                                                    basic
                                                                    color="red"
                                                                    size="mini"
                                                                    type="button"
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();

                                                                        handleDelete(
                                                                            item.id
                                                                        );
                                                                    }}
                                                                    title="Eliminar equipo"
                                                                >
                                                                    <Icon name="trash alternate" />
                                                                </Button>
                                                            )}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                )
                                            )
                                        )}
                                    </Table.Body>
                                </Table>
                            </div>

                            {/* =========================================
                            CONFIRMAR DOCUMENTO
                            ========================================= */}
                            {/* =========================================
    CONFIRMAR DOCUMENTO
========================================= */}

                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginTop: 14,
                                }}
                            >
                                <Button
                                    color="green"
                                    type="button"
                                    loading={confirmandoDocumento}
                                    onClick={() => {
                                        setCabeceraMinimizada(true);
                                        setSeccionActiva("DETALLE");

                                        setShowConfirmationTraspaso(true);
                                    }}
                                    disabled={
                                        esRetornoST
                                            ? !transportistaAsignado ||
                                            confirmandoDocumento
                                            : btnConfirmar ||
                                            confirmandoDocumento
                                    }
                                    icon
                                    labelPosition="left"
                                    style={{
                                        borderRadius: 6,
                                    }}
                                >
                                    <Icon name="check" />

                                    {esRetornoST
                                        ? "Confirmar y enviar a retiro"
                                        : "Confirmar Documento"}
                                </Button>
                            </div>
                        </div>
                    </Segment>

                    {/* =================================================
                    DOCUMENTOS PENDIENTES
                ================================================= */}

                    <Segment
                        style={{
                            background: "#ffffff",
                            border:
                                "1px solid #e5e9ef",
                            borderRadius: 8,
                            boxShadow:
                                "0 1px 3px rgba(9,30,66,0.08)",
                            padding: 0,
                            marginBottom: 18,
                            overflow: "hidden",
                        }}
                    >
                        {/* HEADER */}

                        <div
                            style={{
                                padding: "14px 18px",
                                borderBottom:
                                    "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                    "space-between",
                                gap: 12,
                                flexWrap: "wrap",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                }}
                            >
                                <Icon
                                    name="clipboard list"
                                    style={{
                                        color: "#f2711c",
                                        fontSize: 17,
                                    }}
                                />

                                <span
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 700,
                                        color: "#253858",
                                    }}
                                >
                                    Documentos Pendientes
                                </span>
                            </div>

                            <Label
                                basic
                                size="small"
                                style={{
                                    color: "#6b778c",
                                }}
                            >
                                {cabecera.length}{" "}
                                {cabecera.length === 1
                                    ? "pendiente"
                                    : "pendientes"}
                            </Label>
                        </div>

                        {/* TABLA */}

                        <div
                            style={{
                                padding: 18,
                            }}
                        >
                            <div
                                style={{
                                    maxHeight: 420,
                                    overflowY: "auto",
                                    overflowX: "auto",
                                    border:
                                        "1px solid #e5e9ef",
                                    borderRadius: 6,
                                }}
                            >
                                <Table
                                    celled
                                    compact="very"
                                    unstackable
                                    textAlign="center"
                                    style={{
                                        minWidth: 1100,
                                        margin: 0,
                                    }}
                                >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell
                                                width={1}
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                N°
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Documento
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Folio
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Fecha
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Tipo Traspaso
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Origen
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Rut
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Entidad
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                width={1}
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Cargar
                                            </Table.HeaderCell>

                                            <Table.HeaderCell
                                                width={1}
                                                style={{
                                                    position:
                                                        "sticky",
                                                    top: 0,
                                                    zIndex: 2,
                                                    background:
                                                        "#f8fafc",
                                                }}
                                            >
                                                Anular
                                            </Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>

                                    <Table.Body>
                                        {cabecera.length ===
                                            0 ? (
                                            <Table.Row>
                                                <Table.Cell
                                                    colSpan="10"
                                                    textAlign="center"
                                                    style={{
                                                        padding:
                                                            "26px 10px",
                                                        color:
                                                            "#6b778c",
                                                    }}
                                                >
                                                    No hay documentos
                                                    pendientes por
                                                    confirmar.
                                                </Table.Cell>
                                            </Table.Row>
                                        ) : (
                                            cabecera.map(
                                                (
                                                    item,
                                                    index
                                                ) => (
                                                    <Table.Row
                                                        key={
                                                            item.id ??
                                                            item.id2 ??
                                                            index
                                                        }
                                                        style={
                                                            item.origen_traspaso ===
                                                                "RETORNO_ST_INTERNO"
                                                                ? {
                                                                    backgroundColor:
                                                                        "#eef6ff",
                                                                }
                                                                : {}
                                                        }
                                                    >
                                                        <Table.Cell>
                                                            {index +
                                                                1}
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            {
                                                                item.tipdoc
                                                            }
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            <strong>
                                                                {
                                                                    item.numdoc
                                                                }
                                                            </strong>
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            {formatearFecha(
                                                                item.date
                                                            )}
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            {
                                                                item.tipoinout
                                                            }
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            {item.origen_traspaso ===
                                                                "RETORNO_ST_INTERNO" ? (
                                                                <Label
                                                                    basic
                                                                    color="blue"
                                                                    size="mini"
                                                                >
                                                                    <Icon name="exchange" />
                                                                    RETORNO
                                                                    S.T.
                                                                </Label>
                                                            ) : (
                                                                <Label
                                                                    basic
                                                                    size="mini"
                                                                >
                                                                    NORMAL
                                                                </Label>
                                                            )}
                                                        </Table.Cell>

                                                        <Table.Cell>
                                                            {
                                                                item.rut
                                                            }
                                                        </Table.Cell>

                                                        <Table.Cell
                                                            textAlign="left"
                                                        >
                                                            {
                                                                item.entidad
                                                            }
                                                        </Table.Cell>

                                                        {/* CARGAR */}

                                                        <Table.Cell>
                                                            <Button
                                                                icon
                                                                basic
                                                                color="blue"
                                                                size="mini"
                                                                type="button"
                                                                title="Cargar documento"
                                                                onClick={() => {
                                                                    setFolio(
                                                                        item.numdoc
                                                                    );


                                                                    setNomTipoOut(
                                                                        item.tipoinout
                                                                    );

                                                                    setRut(
                                                                        item.rut
                                                                    );

                                                                    setEntidad(
                                                                        item.entidad
                                                                    );

                                                                    fechaDate(
                                                                        item.date
                                                                    );

                                                                    setCorreo(
                                                                        item.correo ||
                                                                        ""
                                                                    );

                                                                    setPatente(
                                                                        item.patente ||
                                                                        ""
                                                                    );

                                                                    setBtnGuardar(
                                                                        true
                                                                    );

                                                                    setBtnAgregar(
                                                                        false
                                                                    );

                                                                    setConfirmar(
                                                                        true
                                                                    );

                                                                    setBtnNuevo(
                                                                        false
                                                                    );

                                                                    setBtnConfirmar(
                                                                        false
                                                                    );

                                                                    setCabeceraMinimizada(
                                                                        true
                                                                    );



                                                                    setCabId(
                                                                        item.id
                                                                    );

                                                                    setRutSt(
                                                                        item.rutSt ||
                                                                        item.rutst ||
                                                                        item.rut_st ||
                                                                        ""
                                                                    );

                                                                    setEntidadSt(
                                                                        item.entidadSt ||
                                                                        item.entidadst ||
                                                                        item.nombre_st ||
                                                                        ""
                                                                    );

                                                                    setOrigenTraspaso(
                                                                        item.origen_traspaso ||
                                                                        ""
                                                                    );

                                                                    setSeccionActiva(
                                                                        "DETALLE"
                                                                    );
                                                                }}
                                                            >
                                                                <Icon name="arrow up" />
                                                            </Button>
                                                        </Table.Cell>

                                                        {/* ANULAR */}

                                                        <Table.Cell>
                                                            {item.origen_traspaso ===
                                                                "RETORNO_ST_INTERNO" ? (
                                                                <Label
                                                                    basic
                                                                    color="grey"
                                                                    size="mini"
                                                                >
                                                                    <Icon name="lock" />
                                                                </Label>
                                                            ) : (
                                                                <Button
                                                                    basic
                                                                    color="red"
                                                                    icon
                                                                    size="mini"
                                                                    type="button"
                                                                    title="Anular Documento"
                                                                    onClick={() =>
                                                                        handleAnular(
                                                                            item.id
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon name="cancel" />
                                                                </Button>
                                                            )}
                                                        </Table.Cell>
                                                    </Table.Row>
                                                )
                                            )
                                        )}
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>
                    </Segment>

                    {/* =================================================
                    ÚLTIMOS CONFIRMADOS
                ================================================= */}

                    <Segment
                        style={{
                            background: "#ffffff",
                            border:
                                "1px solid #e5e9ef",
                            borderRadius: 8,
                            boxShadow:
                                "0 1px 3px rgba(9,30,66,0.08)",
                            padding: 0,
                            marginBottom: 18,
                            overflow: "hidden",
                        }}
                    >
                        {/* HEADER */}

                        <div
                            style={{
                                padding: "14px 18px",
                                borderBottom:
                                    "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                    "space-between",
                                gap: 12,
                                flexWrap: "wrap",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                }}
                            >
                                <Icon
                                    name="check circle"
                                    style={{
                                        color: "#21ba45",
                                        fontSize: 17,
                                    }}
                                />

                                <div>
                                    <div
                                        style={{
                                            fontSize: 15,
                                            fontWeight: 700,
                                            color: "#253858",
                                        }}
                                    >
                                        Últimos Traspasos
                                        Confirmados
                                    </div>

                                    <div
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                            marginTop: 2,
                                        }}
                                    >
                                        Últimos 5 documentos
                                        confirmados
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* TABLA */}

                        <div
                            style={{
                                padding: 18,
                                overflowX: "auto",
                            }}
                        >
                            <Table
                                celled
                                compact="very"
                                unstackable
                                textAlign="center"
                                style={{
                                    minWidth: 1000,
                                    margin: 0,
                                }}
                            >
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            N°
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            Documento
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            N° Documento
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            Fecha
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            Tipo Traspaso
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            Rut
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            Entidad
                                        </Table.HeaderCell>

                                        <Table.HeaderCell
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >
                                            PDF
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {ultimosConfirmados.length ===
                                        0 ? (
                                        <Table.Row>
                                            <Table.Cell
                                                colSpan="8"
                                                style={{
                                                    padding:
                                                        "26px 10px",
                                                    color:
                                                        "#6b778c",
                                                }}
                                            >
                                                No hay traspasos
                                                confirmados
                                                recientemente.
                                            </Table.Cell>
                                        </Table.Row>
                                    ) : (
                                        ultimosConfirmados.map(
                                            (
                                                item,
                                                index
                                            ) => (
                                                <Table.Row
                                                    key={
                                                        item.id
                                                    }
                                                >
                                                    <Table.Cell>
                                                        {index +
                                                            1}
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        {
                                                            item.tipdoc
                                                        }
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        <strong>
                                                            {
                                                                item.numdoc
                                                            }
                                                        </strong>
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        {formatearFecha(
                                                            item.date
                                                        )}
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        {
                                                            item.tipoinout
                                                        }
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        {item.rut}
                                                    </Table.Cell>

                                                    <Table.Cell
                                                        textAlign="left"
                                                    >
                                                        {
                                                            item.entidad
                                                        }
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        <Button
                                                            size="mini"
                                                            basic
                                                            color="red"
                                                            icon
                                                            labelPosition="left"
                                                            loading={
                                                                cargandoPDFId ===
                                                                item.id
                                                            }
                                                            disabled={
                                                                cargandoPDFId !==
                                                                null
                                                            }
                                                            onClick={() =>
                                                                verPDFDocumento(
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <Icon name="file pdf" />
                                                            PDF
                                                        </Button>
                                                    </Table.Cell>
                                                </Table.Row>
                                            )
                                        )
                                    )}
                                </Table.Body>
                            </Table>
                        </div>
                    </Segment>
                </Container>
            </div>

            {/* =====================================================
            PDF
        ===================================================== */}

            {modalPDF && cabeceraPDF && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "95vw",
                            maxWidth: "1200px",
                            height: "90vh",
                            padding: "20px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent:
                                    "space-between",
                                alignItems: "center",
                                marginBottom: 12,
                                paddingBottom: 10,
                                borderBottom:
                                    "1px solid #e5e9ef",
                            }}
                        >
                            <Header
                                as="h3"
                                style={{
                                    margin: 0,
                                    color: "#253858",
                                }}
                            >
                                <Icon
                                    name="file pdf"
                                    color="red"
                                />
                                Documento de Salida
                            </Header>

                            <Button
                                basic
                                icon
                                onClick={() => {
                                    setModalPDF(false);
                                    setCabeceraPDF(null);
                                    setDetallePDF([]);
                                }}
                            >
                                <Icon name="close" />
                            </Button>
                        </div>

                        <div
                            style={{
                                flex: 1,
                                minHeight: 0,
                            }}
                        >
                            <PDFViewer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    border:
                                        "1px solid #e5e9ef",
                                    borderRadius: 8,
                                }}
                            >
                                <DocumentoSalidaPDF
                                    numDoc={
                                        cabeceraPDF.numdoc
                                    }
                                    nomTipDoc={
                                        cabeceraPDF.tipdoc
                                    }
                                    date={formatearFecha(
                                        cabeceraPDF.date
                                    )}
                                    nomTipoOut={
                                        cabeceraPDF.tipoinout
                                    }
                                    rut={cabeceraPDF.rut}
                                    entidad={
                                        cabeceraPDF.entidad
                                    }
                                    correo={
                                        cabeceraPDF.correo
                                    }
                                    patente={
                                        cabeceraPDF.patente
                                    }
                                    descripcion={
                                        cabeceraPDF.descripcion
                                    }
                                    dataSalida={
                                        detallePDF
                                    }
                                />
                            </PDFViewer>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {/* =====================================================
            ALERTAS
        ===================================================== */}

            <Alertas
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                cambiarEstadoAlerta={
                    cambiarEstadoAlerta
                }
            />
            {/* =====================================================
    MODAL CONFIRMAR TRASPASO
===================================================== */}

            {showConfirmationTraspaso && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 500,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9,30,66,0.22)",
                        }}
                    >
                        {/* =========================================
                HEADER
            ========================================= */}

                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom:
                                    "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#eaf8ee",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name={
                                        esRetornoST
                                            ? "exchange"
                                            : "check circle"
                                    }
                                    style={{
                                        margin: 0,
                                        color: "#21ba45",
                                        fontSize: 19,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.25,
                                    }}
                                >
                                    {esRetornoST
                                        ? "Confirmar retorno desde Servicio Técnico"
                                        : "Confirmar traspaso"}
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Revise la información antes de continuar
                                </div>
                            </div>
                        </div>

                        {/* =========================================
                CONTENIDO
            ========================================= */}

                        <div
                            style={{
                                padding: 20,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                {esRetornoST
                                    ? "¿Está seguro de que desea confirmar este retorno y dejarlo disponible para retiro por el transportista asignado?"
                                    : "¿Está seguro de que desea confirmar este documento de traspaso?"}
                            </div>

                            {/* INFORMACIÓN DEL DOCUMENTO */}

                            <div
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 7,
                                    padding: "12px 14px",
                                    marginBottom: 16,
                                }}
                            >
                                {/* FOLIO */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Folio
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 14,
                                        }}
                                    >
                                        {folio || "—"}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                {/* MOVIMIENTO */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Movimiento
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 13,
                                            textAlign: "right",
                                        }}
                                    >
                                        {nomTipoOut || "—"}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                {/* PACIENTE */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Paciente
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 13,
                                            textAlign: "right",
                                        }}
                                    >
                                        {entidad || "—"}
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                {/* EQUIPOS */}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent:
                                            "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Equipos
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 14,
                                        }}
                                    >
                                        {dataSalida.length}
                                    </strong>
                                </div>

                                {/* TRANSPORTISTA SOLO RETORNO */}

                                {esRetornoST && (
                                    <>
                                        <div
                                            style={{
                                                height: 1,
                                                background:
                                                    "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent:
                                                    "space-between",
                                                alignItems:
                                                    "center",
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                Transportista
                                            </span>

                                            <strong
                                                style={{
                                                    color:
                                                        "#253858",
                                                    fontSize: 13,
                                                    textAlign:
                                                        "right",
                                                }}
                                            >
                                                {correo ||
                                                    "—"}
                                            </strong>
                                        </div>

                                        <div
                                            style={{
                                                height: 1,
                                                background:
                                                    "#e5e9ef",
                                                margin: "9px 0",
                                            }}
                                        />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent:
                                                    "space-between",
                                                alignItems:
                                                    "center",
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#6b778c",
                                                }}
                                            >
                                                Patente
                                            </span>

                                            <strong
                                                style={{
                                                    color:
                                                        "#253858",
                                                    fontSize: 13,
                                                }}
                                            >
                                                {patente ||
                                                    "—"}
                                            </strong>
                                        </div>
                                    </>
                                )}
                            </div>

                            {/* AVISO OPERACIONAL */}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    alignItems: "flex-start",
                                    background: esRetornoST
                                        ? "#eef6ff"
                                        : "#f0fff4",
                                    border: esRetornoST
                                        ? "1px solid #cce4ff"
                                        : "1px solid #c6f6d5",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: esRetornoST
                                            ? "#2185d0"
                                            : "#21ba45",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    {esRetornoST ? (
                                        <>
                                            Al confirmar, el documento
                                            quedará preparado para que el
                                            transportista realice el retiro
                                            desde Servicio Técnico.
                                        </>
                                    ) : (
                                        <>
                                            Al confirmar, los equipos
                                            cambiarán a estado de tránsito
                                            según el tipo de movimiento
                                            seleccionado.
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* =========================================
                ACCIONES
            ========================================= */}

                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop:
                                    "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                disabled={
                                    confirmandoDocumento
                                }
                                onClick={() =>
                                    setShowConfirmationTraspaso(
                                        false
                                    )
                                }
                            >
                                Cancelar
                            </Button>

                            <Button
                                positive
                                type="button"
                                loading={
                                    confirmandoDocumento
                                }
                                disabled={
                                    confirmandoDocumento
                                }
                                icon
                                labelPosition="left"
                                onClick={async () => {
                                    try {
                                        if (esRetornoST) {
                                            await confirmarRetornoST();
                                        } else {
                                            await actualizarDocs();
                                        }

                                        setShowConfirmationTraspaso(
                                            false
                                        );
                                    } catch (error) {
                                        console.error(
                                            "Error confirmando traspaso:",
                                            error
                                        );
                                    }
                                }}
                            >
                                <Icon name="check" />

                                {esRetornoST
                                    ? "Confirmar retorno"
                                    : "Confirmar traspaso"}
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}

            {/* =====================================================
    MODAL ELIMINAR EQUIPO
===================================================== */}

            {showConfirmation && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow: "0 18px 48px rgba(9,30,66,0.22)"
                        }}
                    >
                        {/* HEADER */}

                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    borderRadius: 8,
                                    background: "#fff3eb",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center"
                                }}
                            >
                                <Icon
                                    name="trash alternate"
                                    style={{
                                        margin: 0,
                                        color: "#f2711c",
                                        fontSize: 18
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d"
                                    }}
                                >
                                    Eliminar equipo del documento
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3
                                    }}
                                >
                                    Se eliminará únicamente este equipo del traspaso.
                                </div>
                            </div>
                        </div>

                        {/* CONTENIDO */}

                        <div
                            style={{
                                padding: 20
                            }}
                        >
                            <p
                                style={{
                                    color: "#344563",
                                    fontSize: 14,
                                    lineHeight: 1.6,
                                    marginBottom: 16
                                }}
                            >
                                ¿Desea quitar este equipo del documento de traspaso?
                            </p>

                            <div
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 7,
                                    padding: "12px 14px"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        marginBottom: 6
                                    }}
                                >
                                    <Icon
                                        name="info circle"
                                        style={{ color: "#2185d0" }}
                                    />

                                    <strong style={{ color: "#253858" }}>
                                        ¿Qué ocurrirá?
                                    </strong>
                                </div>

                                <ul
                                    style={{
                                        margin: 0,
                                        paddingLeft: 20,
                                        color: "#5e6c84",
                                        fontSize: 13,
                                        lineHeight: 1.6
                                    }}
                                >
                                    <li>El equipo será eliminado del detalle del documento.</li>
                                    <li>El documento de traspaso permanecerá abierto.</li>
                                    <li>El estado del equipo no cambiará.</li>
                                </ul>
                            </div>
                        </div>

                        {/* BOTONES */}

                        <div
                            style={{
                                padding: "14px 20px",
                                borderTop: "1px solid #e5e9ef",
                                background: "#f8fafc",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10
                            }}
                        >
                            <Button basic type="button" onClick={cancelDelete}>
                                Cancelar
                            </Button>

                            <Button
                                color="orange"
                                type="button"
                                onClick={borrarItem}
                                icon
                                labelPosition="left"
                            >
                                <Icon name="trash alternate" />
                                Eliminar equipo
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
    MODAL ANULAR DOCUMENTO
===================================================== */}

            {showConfirmationAnular && (
                <Overlay>
                    <ConfirmaModal
                        style={{
                            width: "92%",
                            maxWidth: 460,
                            padding: 0,
                            overflow: "hidden",
                            borderRadius: 10,
                            background: "#ffffff",
                            boxShadow:
                                "0 18px 48px rgba(9, 30, 66, 0.22)",
                        }}
                    >
                        {/* =========================================
                HEADER
            ========================================= */}

                        <div
                            style={{
                                padding: "18px 20px",
                                borderBottom: "1px solid #e5e9ef",
                                display: "flex",
                                alignItems: "center",
                                gap: 12,
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    width: 42,
                                    height: 42,
                                    minWidth: 42,
                                    borderRadius: 8,
                                    background: "#ffebe6",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <Icon
                                    name="exclamation triangle"
                                    style={{
                                        margin: 0,
                                        color: "#db2828",
                                        fontSize: 19,
                                    }}
                                />
                            </div>

                            <div>
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                        color: "#172b4d",
                                        lineHeight: 1.25,
                                    }}
                                >
                                    Anular documento
                                </div>

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#6b778c",
                                        marginTop: 3,
                                    }}
                                >
                                    Esta acción eliminará el detalle pendiente
                                </div>
                            </div>
                        </div>

                        {/* =========================================
                CONTENIDO
            ========================================= */}

                        <div
                            style={{
                                padding: "20px",
                                textAlign: "left",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 14,
                                    color: "#344563",
                                    lineHeight: 1.6,
                                    marginBottom: 16,
                                }}
                            >
                                ¿Está seguro de que desea anular este documento
                                de traspaso?
                            </div>

                            {/* INFORMACIÓN DOCUMENTO */}

                            <div
                                style={{
                                    background: "#f8fafc",
                                    border: "1px solid #e5e9ef",
                                    borderRadius: 7,
                                    padding: "12px 14px",
                                    marginBottom: 16,
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Documento
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 13,
                                        }}
                                    >
                                        TRASPASOS
                                    </strong>
                                </div>

                                <div
                                    style={{
                                        height: 1,
                                        background: "#e5e9ef",
                                        margin: "9px 0",
                                    }}
                                />

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        gap: 10,
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: 12,
                                            color: "#6b778c",
                                        }}
                                    >
                                        Folio
                                    </span>

                                    <strong
                                        style={{
                                            color: "#253858",
                                            fontSize: 14,
                                        }}
                                    >
                                        {cabecera.find(
                                            (d) => d.id === itemAnular
                                        )?.numdoc || "—"}
                                    </strong>
                                </div>
                            </div>

                            {/* ADVERTENCIA */}

                            <div
                                style={{
                                    display: "flex",
                                    gap: 10,
                                    alignItems: "flex-start",
                                    background: "#fff7f5",
                                    border: "1px solid #ffd5cc",
                                    borderRadius: 7,
                                    padding: "11px 12px",
                                }}
                            >
                                <Icon
                                    name="info circle"
                                    style={{
                                        color: "#db2828",
                                        marginTop: 2,
                                    }}
                                />

                                <div
                                    style={{
                                        fontSize: 12,
                                        color: "#5e6c84",
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Los equipos agregados a este documento serán
                                    eliminados del detalle y el documento quedará
                                    registrado como anulado.
                                </div>
                            </div>
                        </div>

                        {/* =========================================
                ACCIONES
            ========================================= */}

                        <div
                            style={{
                                padding: "14px 20px",
                                background: "#f8fafc",
                                borderTop: "1px solid #e5e9ef",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10,
                            }}
                        >
                            <Button
                                basic
                                type="button"
                                onClick={cancelAnular}
                            >
                                Cancelar
                            </Button>

                            <Button
                                negative
                                type="button"
                                onClick={anular}
                                icon
                                labelPosition="left"
                            >
                                <Icon name="ban" />
                                Anular documento
                            </Button>
                        </div>
                    </ConfirmaModal>
                </Overlay>
            )}
            {/* =====================================================
            MODAL EQUIPOS DISPONIBLES
        ===================================================== */}

            <Modal
                open={modalEquipos}
                onClose={() => {
                    if (!guardandoEquipo) {
                        setModalEquipos(false);
                        setBuscadorEquipos("");
                    }
                }}
                size="large"
            >
                <Modal.Header
                    style={{
                        padding: "16px 20px",
                        borderBottom:
                            "1px solid #e5e9ef",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <div
                            style={{
                                width: 36,
                                height: 36,
                                borderRadius: 6,
                                background: "#e8f7f8",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Icon
                                name="boxes"
                                style={{
                                    margin: 0,
                                    color: "#0d9da5",
                                }}
                            />
                        </div>

                        <div>
                            <div
                                style={{
                                    color: "#253858",
                                    fontWeight: 700,
                                    fontSize: 16,
                                }}
                            >
                                Equipos disponibles
                            </div>

                            <div
                                style={{
                                    color: "#6b778c",
                                    fontSize: 12,
                                    marginTop: 2,
                                }}
                            >
                                Seleccione el equipo que desea
                                agregar al traspaso
                            </div>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Content scrolling>
                    <Input
                        fluid
                        icon="search"
                        placeholder="Buscar por serie, familia, tipo, marca o modelo..."
                        value={buscadorEquipos}
                        onChange={(e) =>
                            setBuscadorEquipos(
                                e.target.value
                            )
                        }
                        style={{
                            marginBottom: 18,
                        }}
                    />

                    <div
                        style={{
                            border:
                                "1px solid #e5e9ef",
                            borderRadius: 6,
                            overflowX: "auto",
                        }}
                    >
                        <Table
                            celled
                            selectable
                            compact="very"
                            unstackable
                            style={{
                                margin: 0,
                                minWidth: 850,
                            }}
                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Serie
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Familia
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Tipo
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Marca
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Modelo
                                    </Table.HeaderCell>

                                    <Table.HeaderCell
                                        textAlign="center"
                                        style={{
                                            background:
                                                "#f8fafc",
                                        }}
                                    >
                                        Acción
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {equiposDisponiblesFiltrados.length === 0 ? (
                                    <Table.Row>
                                        <Table.Cell
                                            colSpan="6"
                                            textAlign="center"
                                            style={{
                                                padding: "28px 10px",
                                                color: "#6b778c",
                                            }}
                                        >
                                            <Icon name="search" />
                                            No se encontraron equipos disponibles.
                                        </Table.Cell>
                                    </Table.Row>
                                ) : (
                                    equiposDisponiblesFiltrados.map((item) => (
                                        <Table.Row key={item.id}>
                                            <Table.Cell>
                                                <strong>
                                                    {item.serie}
                                                </strong>
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.familia}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.tipo}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.marca}
                                            </Table.Cell>

                                            <Table.Cell>
                                                {item.modelo}
                                            </Table.Cell>

                                            <Table.Cell textAlign="center">
                                                <Button
                                                    icon
                                                    size="mini"
                                                    loading={
                                                        guardandoEquipo ||
                                                        consultandoMantencion
                                                    }
                                                    disabled={
                                                        guardandoEquipo ||
                                                        consultandoMantencion ||
                                                        esRetornoST
                                                    }
                                                    onClick={(e) =>
                                                        prepararEquipoSTInterno(
                                                            e,
                                                            item
                                                        )
                                                    }
                                                    title="Agregar equipo"
                                                    style={{
                                                        background: "#0d9da5",
                                                        color: "#ffffff",
                                                    }}
                                                >
                                                    <Icon name="plus" />
                                                </Button>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))
                                )}
                            </Table.Body>
                        </Table>
                    </div>
                </Modal.Content>

                <Modal.Actions
                    style={{
                        borderTop:
                            "1px solid #e5e9ef",
                    }}
                >
                    <Button
                        basic
                        type="button"
                        disabled={guardandoEquipo}
                        onClick={() => {
                            setModalEquipos(false);
                            setBuscadorEquipos("");
                        }}
                    >
                        <Icon name="close" />
                        Cerrar
                    </Button>
                </Modal.Actions>
            </Modal>

            <ModalAtencionST
                open={modalAtencionST}

                equipo={
                    equipoAtencionST
                }

                mantencion={
                    mantencionAtencionST
                }

                diasRestantes={
                    diasRestantesMantencion
                }

                preventivaDisponible={
                    preventivaDisponible
                }

                guardando={
                    guardandoEquipo
                }

                onClose={
                    cerrarModalAtencionST
                }

                onConfirmar={
                    confirmarAtencionST
                }
            />

            {/* =====================================================
            MODAL TRANSPORTISTA
        ===================================================== */}

            <Modal
                open={modalTransportista}
                onClose={() => {
                    if (!asignandoTransportista) {
                        setModalTransportista(false);
                    }
                }}
                size="small"
                closeIcon={!asignandoTransportista}
            >
                <Modal.Header
                    style={{
                        padding: "16px 20px",
                        borderBottom:
                            "1px solid #e5e9ef",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <div
                            style={{
                                width: 36,
                                height: 36,
                                borderRadius: 6,
                                background: "#eaf4fb",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <Icon
                                name="truck"
                                style={{
                                    margin: 0,
                                    color: "#2185d0",
                                }}
                            />
                        </div>

                        <div
                            style={{
                                color: "#253858",
                                fontSize: 16,
                                fontWeight: 700,
                            }}
                        >
                            Asignar transportista
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Content>
                    <Message info>
                        Seleccione el transportista que
                        retirará el equipo desde Servicio
                        Técnico.
                    </Message>

                    <Form>
                        <Form.Field>
                            <label>Transportista</label>

                            <Dropdown
                                fluid
                                selection
                                search
                                placeholder="Seleccione transportista"
                                options={
                                    opcionesTransportistas
                                }
                                value={
                                    correoTransportistaTmp
                                }
                                onChange={(e, { value }) =>
                                    setCorreoTransportistaTmp(
                                        value
                                    )
                                }
                                disabled={
                                    asignandoTransportista
                                }
                            />
                        </Form.Field>

                        <Form.Field>
                            <label>Patente vehículo</label>

                            <Input
                                fluid
                                placeholder="Ej: ABCD12"
                                value={
                                    patenteTransportistaTmp
                                }
                                onChange={(e) =>
                                    setPatenteTransportistaTmp(
                                        e.target.value.toUpperCase()
                                    )
                                }
                                disabled={
                                    asignandoTransportista
                                }
                            />
                        </Form.Field>
                    </Form>
                </Modal.Content>

                <Modal.Actions>
                    <Button
                        basic
                        type="button"
                        onClick={() =>
                            setModalTransportista(false)
                        }
                        disabled={
                            asignandoTransportista
                        }
                    >
                        Cancelar
                    </Button>

                    <Button
                        color="blue"
                        type="button"
                        onClick={
                            asignarTransportistaRetorno
                        }
                        loading={
                            asignandoTransportista
                        }
                        disabled={
                            asignandoTransportista ||
                            !correoTransportistaTmp ||
                            !patenteTransportistaTmp.trim()
                        }
                    >
                        <Icon name="check" />
                        Asignar
                    </Button>
                </Modal.Actions>
            </Modal>
        </>
    );
};
export default Traspasos;